import React, { useState } from 'react';
import ReactDOM from "react-dom";
import { connect } from 'react-redux';
import withRouter from 'with-router';
import { Route, Prompt, Link } from 'react-router-dom';
import ContextGuardDialog, { guardReason } from './ContextGuardDialog';
import LoadingIndicator from './LoadingIndicator';
import { setUnsavedEdits } from '../modules/editing';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import { styled } from '@mui/material/styles';
import { bindActionCreators } from 'redux'
import TablePagination from '@mui/material/TablePagination';
import LinearProgress from '@mui/material/LinearProgress';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import Tooltip from '@mui/material/Tooltip';
import DeleteIcon from '@mui/icons-material/Delete';
import SaveIcon from '@mui/icons-material/Save';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Collapse from '@mui/material/Collapse';
import InputBase from '@mui/material/InputBase';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import FilterListIcon from '@mui/icons-material/FilterList';
import Chip from '@mui/material/Chip';
import StorefrontOutlinedIcon from '@mui/icons-material/StorefrontOutlined';
import Badge from '@mui/material/Badge';
import Select from '@mui/material/Select';
import SortSharpIcon from '@mui/icons-material/SortSharp';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ArrowBackOutlined from '@mui/icons-material/ArrowBackOutlined';
import ArrowForwardOutlined from '@mui/icons-material/ArrowForwardOutlined';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import ExpandMore from '@mui/icons-material/ExpandMore';
import CloseIcon from '@mui/icons-material/Close';
import MenuIcon from '@mui/icons-material/Menu';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';
import SaveAltOutlinedIcon from '@mui/icons-material/SaveAltOutlined';
import WarningOutlinedIcon from '@mui/icons-material/WarningOutlined';
import Divider from '@mui/material/Divider';
import Sticky from 'react-sticky-el';
import TranslationFields from './TranslationFields';
import { hasAdjustedValue } from './TranslationField';
import CodeOutlinedIcon from '@mui/icons-material/CodeOutlined';
import { markupIssues } from '../markupCheck';
import DeleteFieldsDialog from './DeleteFieldsDialog';
import NewBadge from './NewBadge';
import DeleteSweepOutlinedIcon from '@mui/icons-material/DeleteSweepOutlined';
import { SaveErrorsList, SaveInfosList } from './SnackbarItems';
import ProgressToolbar from './ProgressToolbar.js';
import ProgressIndicator from './ProgressIndicator.js';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ResaveIcon from '@mui/icons-material/Replay';
import ClearAllIcon from '@mui/icons-material/ClearAll';
import CircularProgress from '@mui/material/CircularProgress';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import StopIcon from '@mui/icons-material/Stop';
import AddIcon from '@mui/icons-material/Add';
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import { Trans, withTranslation, useTranslation } from 'react-i18next';
import { Alert } from '@mui/material';
import { withSnackbar } from '../utils/withSnackbar';
import { parseItemId } from '../helper';
import ErrorBoundary from './ErrorBoundary'
import _ from 'lodash';

import { red } from '@mui/material/colors';

const REACT_APP_ITEMSLIST_OPENING_ANIMATION = window.loadEnv("REACT_APP_ITEMSLIST_OPENING_ANIMATION", process.env.REACT_APP_ITEMSLIST_OPENING_ANIMATION);

// Bulk translation task states that no longer block editing of a section.
// Anything else (running, pending, unknown) keeps the section locked.
const BULK_TASK_FINISHED_STATES = ['completed', 'finished', 'canceled', 'cancelled', 'error', 'failed'];

// Sorting
function desc(a, b, orderBy) {
  const varA = (typeof a[orderBy] === 'string') ? a[orderBy].toLowerCase() : a[orderBy];
  const varB = (typeof b[orderBy] === 'string') ? b[orderBy].toLowerCase() : b[orderBy];
  if (varB < varA) {
    return -1;
  }
  if (varB > varA) {
    return 1;
  }
  return 0;
}
function getSorting(order, orderBy) {
  return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}
function stableSort(array, cmp) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = cmp(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map(el => el[0]);
}

// the captured order, applied to whatever survived the filter - the item-level twin of
// TranslationFields' applyFieldRanks. Ids the snapshot does not know keep their own order at the end
function applyItemRanks(items, ranks) {
  const rankOf = item => ranks[item.id] === undefined ? Number.MAX_SAFE_INTEGER : ranks[item.id];
  return items
    .map((item, index) => ({ item, index }))
    .sort((a, b) => (rankOf(a.item) - rankOf(b.item)) || (a.index - b.index))
    .map(entry => entry.item);
}

// Filtering
// searchFieldLabels: opt in where the label means something on its own - a theme
// string's key, a metafield's namespace + key
function filterItems(array, query, group, searchFieldLabels) {
  let returnedArray = array;
  

  // Step 1: Filter for field-groups like "outdated" handling
  if(group) {
    returnedArray = returnedArray.filter(el => {
      let inFieldsCheck = false;
      if(el.fields) {
        for (let i = 0; i < el.fields.length; i++) {
          if(el.fields[i].type != 'subfields' && el.fields[i].type != 'image') {

            // show items with true "outdated" field
            if(group === 'outdated') {
              if(el.fields[i].outdated && el.fields[i].outdated === true) {
                inFieldsCheck = true;
                break;
              }
            }

            //
            //
            // Add new conditions here
            // ...

            // show all items
            if(group && group === 'all') {
              inFieldsCheck = true;
              break;
            }
          }
        }
      }
      return inFieldsCheck;
    });    
  }

  

  // Step 2: Filter query string handling
  returnedArray = returnedArray.filter(el => {
    let inFieldsCheck = false;
    if(el.fields) {
      for (let i = 0; i < el.fields.length; i++) {
        if(el.fields[i].type != 'subfields' && el.fields[i].type != 'image') {

          
          // Filter in this fields:
          const fields = [
            // Check if this field is present in window.restoreFieldsData[`${id}${parentId}-${data.id}`]
            // When it is, also add the item's value here in order that the field isn't filtered and disappears when you filter for a target text which is beeing altered.
            window.restoreFieldsData[`${el.id}-${el.fields[i].id}`] || null, 
            
            el.fields[i].source,
            el.fields[i].target ? el.fields[i].target : null,
            searchFieldLabels ? el.fields[i].label : null,
          ];
          if(fields.join(' ').toLowerCase().indexOf(query.toLowerCase()) > -1) {
            inFieldsCheck = true;
            break;
          }
        }
      }      
    }
    return el.title.concat(el.shopify_id).toLowerCase().indexOf(query.toLowerCase()) > -1 || inFieldsCheck
  });

  return returnedArray;
}

// Pagination
function paginateItems(array, paginate, page, rowsPerPage) {
  if(paginate) {
    return array.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
  } else {
    return array
  }
}

class ItemsListToolbar extends React.Component {
  state = {
    anchorEl: null,
    sorting: localStorage.getItem('ly_orderBy') ? `${localStorage.getItem('ly_orderBy')}${localStorage.getItem('ly_order')}` : 'titleasc',
    filterQuery: '',
    filterGroup: 'all',
  };

  handleClick = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  handleSort = (field, order) => {
    this.handleClose();
    this.setState({sorting: `${field}${order}`})
    this.props.onSort(field, order);
  }

  handleReapply = () => {
    this.handleClose();
    this.props.onReapply();
  }

  handleSortFields = (field, order) => {
    this.handleClose();
    this.props.onSortFields(field, order);
  }

  handleReapplyFields = () => {
    this.handleClose();
    this.props.onReapplyFields();
  }

  handleResetFields = () => {
    this.handleClose();
    this.props.onResetFields();
  }

  handleFilterGroup = (group) => {
    this.handleClose();
    this.setState({filterGroup: group})
    this.props.onFilterGroup(group);
  }

  onFilterChange = (event) => {
    this.setState({ filterQuery: event.target.value })
    if(this.props.onQueryChange) {
      this.props.onQueryChange(event);
    }
  }

  onDiscard = (event) => {
    if(this.props.onDiscard) {
      this.props.onDiscard(event);
    }
  }

  onResetQuery = () => {
    this.onFilterChange({ 
      target: {
        value: ''
      } 
    });
  }

  onRemoveFilterGroup = (event) => {
    this.handleFilterGroup('all');
  }


  render() {
    const { t, data, numSelected, isSticky, hideFilterbar, hideSorting, allowGroupFiltering, toolbarTitle, filterDisabled, classes, sortFields, fieldSorting, flagsOutdated } = this.props;
    const { filterQuery, filterGroup, anchorEl, sorting } = this.state;

    return (
      <React.Fragment>
        {numSelected > 0 &&
          <React.Fragment>
            <Toolbar className={classNames(classes.root, classes.actionBar, {
              [classes.highlight]: numSelected > 0,
            })} elevation={0}>
              <IconButton
                color="inherit"
                aria-label="Open drawer"
                onClick={this.handleDrawerOpen}
                className={classNames(
                  classes.menuButton,
                  this.state.open && classes.hidden,
                )}
                size="large">
                <MenuIcon />
              </IconButton>

              <Typography component="h1" variant="h6" color="inherit" noWrap
                className={classNames(classes.appBarLogo, this.state.open && classes.hidden)}>
                {/*
                  Im Dark Mode läuft die Leiste auf secondary.dark, dort
                  erreicht das Indigo-Logo nur 1.70:1. Gegenstück wie in
                  containers/app/index.js, wo bereits so umgeschaltet wird.
                */}
                <img className="logo-img" src={this.props.theme?.palette.mode === 'dark' ? "/langify-logo-white.svg" : "/langify-logo-accent.svg"} style={{width: 110, marginTop: -2}} alt={"logo"}/>
              </Typography>
              <Typography color="inherit" variant="h6" style={{fontSize: '1.1rem', fontWeight: 400}} className="actionbar-text">
                {numSelected} {numSelected>1 ? t('itemsList.unsavedSections') : t('itemsList.unsavedSection')}
              </Typography>
              <div className={classes.actions}>
                <Button
                  aria-label="Cancel"
                  color="primary"
                  variant="outlined"
                  size="small"
                  onClick={this.props.onDiscard}
                  disabled={this.props.isPending}
                  style={{marginRight: 8}}>
                  {t('system.discard')}
                </Button>
                <Button
                  aria-label="Save All"
                  color="primary"
                  variant="contained"
                  size="small"
                  onClick={this.props.onSave}
                  disabled={this.props.isPending}
                >
                  {t('system.save')} <SaveAltOutlinedIcon style={{marginLeft: 5}} />
                </Button>
              </div>
              <Divider className={classes.divider} />
            </Toolbar>
          </React.Fragment>
        }
        <Sticky
          scrollElement="#mainFrame"   
          topOffset={0}
          disabled={!isSticky}
          stickyClassName={classes.sticky}
          hideOnBoundaryHit={true}
          positionRecheckInterval={100}
        >
          <Toolbar
            data-tour="items-filter-bar"
            className={classNames(classes.root)}
          >
            {!this.props.filterModules && <div className={classes.title}>
              <React.Fragment>
                  {hideFilterbar ?
                    <Typography variant="subtitle1" color="text.secondary">
                      {toolbarTitle ? toolbarTitle : 'Metadata'}
                    </Typography>
                  :
                    <React.Fragment>
                      <InputBase
                        style={{ margin: 0 }}
                        onChange={this.onFilterChange}
                        value={filterQuery}
                        // what the box matches: field keys where the section searches labels (theme,
                        // metafields), title and Shopify id where the items carry one, plain text otherwise
                        placeholder={t(this.props.searchFieldLabels ? 'itemsList.filterPlaceholderTextKey'
                          : ((data || []).some(item => typeof item.shopify_id !== 'undefined') ? 'itemsList.filterPlaceholderTitleId' : 'itemsList.filterPlaceholderText'))}
                        fullWidth
                        disabled={filterDisabled}
                        startAdornment={<SearchOutlinedIcon style={{opacity: .5, marginRight:10}} />}
                      />
                      {filterQuery &&
                        <span className={classNames(classes.closeIcon)}>
                          <CloseIcon onClick={this.onResetQuery}/>
                        </span>
                      }
                    </React.Fragment>
                  }
                </React.Fragment>
            </div>}
            {!this.props.filterModules && <div className={classes.spacer} />}
            <div className={classes.actions} 
              style={{
                width: this.props.filterModules ? '100%' : 'auto',
                display: this.props.filterModules ? 'flex' : 'inline-block',
              }}
            >

              {this.props.filterModules && 
                this.props.filterModules.map((module, index) => {
                  return module;
                })
              }

              {!this.props.filterModules && allowGroupFiltering &&
                <span style={{position: 'relative', marginLeft: 8}}>
                  {(filterGroup && filterGroup !== 'all') &&
                    <Chip color="secondary" size="medium" label={filterGroup} onDelete={this.onRemoveFilterGroup} className={classes.filterChip} />
                  }
                  <Tooltip title={t('itemsList.filterFieldTooltip')} disableTouchListener disableFocusListener arrow>
                    <span>
                    <IconButton
                      aria-owns={'filter-menu'}
                      aria-haspopup="true"
                      aria-label={t('itemsList.filterFieldTooltip')}
                      onClick={this.handleClick}
                      style={{ borderRadius: 0}}
                      disabled={filterDisabled}
                      size="large">
                      <FilterListIcon />
                    </IconButton>
                    </span>
                  </Tooltip>
                  <Menu
                    id="filter-menu"
                    anchorEl={anchorEl}
                    open={anchorEl && anchorEl.getAttribute('aria-owns') === 'filter-menu'}
                    onClose={this.handleClose}
                    anchorOrigin={{
                      vertical: 'top',
                      horizontal: 'left',
                    }}
                    transformOrigin={{
                      vertical: 'top',
                      horizontal: 'right',
                    }}
                    classes={{
                      paper: classes.sortMenu,
                    }}
                    disableAutoFocusItem
                  >
                    <MenuItem selected={(filterGroup === 'all')} onClick={() => this.handleFilterGroup('all')}><Trans i18nKey={'itemsList.filterAll'}></Trans></MenuItem>
                    <MenuItem selected={(filterGroup === 'outdated')} onClick={() => this.handleFilterGroup('outdated')}><Trans i18nKey={'itemsList.filterOutdated'}></Trans></MenuItem>
                  </Menu>                
                </span>
              }
              {!this.props.filterModules && !hideSorting &&
                <span style={{position: 'relative', marginLeft: 8}}>
                  <Tooltip title={t('itemsList.sortFieldTooltip')} disableTouchListener disableFocusListener arrow>
                    <span>
                    <IconButton
                      aria-owns={'sort-menu'}
                      aria-haspopup="true"
                      aria-label={t('itemsList.sortFieldTooltip')}
                      onClick={this.handleClick}
                      disabled={filterDisabled}
                      size="large">
                      {/* the sort survives in localStorage, so a merchant meets it again on a
                          later visit with nothing on screen explaining the order */}
                      <Badge color="secondary" variant="dot" invisible={sorting === 'titleasc'}>
                        <SortSharpIcon />
                      </Badge>
                    </IconButton>
                    </span>
                  </Tooltip>
                  <Menu
                    id="sort-menu"
                    anchorEl={anchorEl}
                    open={(anchorEl && anchorEl.getAttribute('aria-owns') === 'sort-menu') ? true : false}
                    onClose={this.handleClose}
                    anchorOrigin={{
                      vertical: 'top',
                      horizontal: 'left',
                    }}
                    transformOrigin={{
                      vertical: 'top',
                      horizontal: 'right',
                    }}
                    classes={{
                      paper: classes.sortMenu,
                    }}
                    disableAutoFocusItem
                  >
                    <MenuItem selected={(sorting === 'titleasc')} onClick={() => this.handleSort('title', 'asc')}><Trans i18nKey={'itemsList.sortAbcAsc'}></Trans></MenuItem>
                    <MenuItem selected={(sorting === 'titledesc')} onClick={() => this.handleSort('title', 'desc')}><Trans i18nKey={'itemsList.sortAbcDesc'}></Trans></MenuItem>
                    <MenuItem selected={(sorting === 'progressasc')} onClick={() => this.handleSort('progress', 'asc')}><Trans i18nKey={'itemsList.sortProgressAsc'}></Trans></MenuItem>
                    <MenuItem selected={(sorting === 'progressdesc')} onClick={() => this.handleSort('progress', 'desc')}><Trans i18nKey={'itemsList.sortProgressDesc'}></Trans></MenuItem>
                    <Divider />
                    <MenuItem onClick={this.handleReapply}><Trans i18nKey={'itemsList.sortReapply'}></Trans></MenuItem>
                  </Menu>
                </span>
              }
              {/* sorts the entries inside each section, where the sort above orders the sections */}
              {!this.props.filterModules && sortFields &&
                <span style={{position: 'relative', marginLeft: 8}}>
                  <Tooltip title={t('itemsList.sortEntriesTooltip')} disableTouchListener disableFocusListener arrow>
                    <span>
                    <IconButton
                      aria-owns={'field-sort-menu'}
                      aria-haspopup="true"
                      aria-label={t('itemsList.sortEntriesTooltip')}
                      onClick={this.handleClick}
                      disabled={filterDisabled}
                      size="large">
                      <Badge color="secondary" variant="dot" invisible={!fieldSorting}>
                        <SortSharpIcon />
                      </Badge>
                    </IconButton>
                    </span>
                  </Tooltip>
                  <Menu
                    id="field-sort-menu"
                    anchorEl={anchorEl}
                    open={(anchorEl && anchorEl.getAttribute('aria-owns') === 'field-sort-menu') ? true : false}
                    onClose={this.handleClose}
                    anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
                    transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                    classes={{ paper: classes.sortMenu }}
                    disableAutoFocusItem
                  >
                    <MenuItem selected={!fieldSorting} onClick={this.handleResetFields}><Trans i18nKey={'itemsList.sortDefault'}></Trans></MenuItem>
                    <MenuItem selected={(fieldSorting === 'labelasc')} onClick={() => this.handleSortFields('label', 'asc')}><Trans i18nKey={'itemsList.sortFieldAbcAsc'}></Trans></MenuItem>
                    <MenuItem selected={(fieldSorting === 'labeldesc')} onClick={() => this.handleSortFields('label', 'desc')}><Trans i18nKey={'itemsList.sortFieldAbcDesc'}></Trans></MenuItem>
                    <MenuItem selected={(fieldSorting === 'translatedasc')} onClick={() => this.handleSortFields('translated', 'asc')}><Trans i18nKey={'itemsList.sortUntranslatedFirst'}></Trans></MenuItem>
                    <MenuItem selected={(fieldSorting === 'translateddesc')} onClick={() => this.handleSortFields('translated', 'desc')}><Trans i18nKey={'itemsList.sortTranslatedFirst'}></Trans></MenuItem>
                    {flagsOutdated === true &&
                      <MenuItem selected={(fieldSorting === 'outdatedasc')} onClick={() => this.handleSortFields('outdated', 'asc')}><Trans i18nKey={'itemsList.sortOutdatedFirst'}></Trans></MenuItem>
                    }
                    <Divider />
                    <MenuItem disabled={!fieldSorting} onClick={this.handleReapplyFields}><Trans i18nKey={'itemsList.sortReapply'}></Trans></MenuItem>
                  </Menu>
                </span>
              }
            </div>
          </Toolbar>
        {(filterQuery && data.length == 0) &&
          <div>
            <Divider />
            <Typography variant="h5" align="center" style={{padding: 24}}>
              {t('itemsList.noMatchesFound')}
            </Typography>
          </div>
        }
      </Sticky>
      </React.Fragment>
    );
  }

}

const TOOLBAR_PREFIX = 'ItemsListToolbar';
const toolbarClasses = {
  root: `${TOOLBAR_PREFIX}-root`,
  highlight: `${TOOLBAR_PREFIX}-highlight`,
  actionBar: `${TOOLBAR_PREFIX}-actionBar`,
  actions: `${TOOLBAR_PREFIX}-actions`,
  spacer: `${TOOLBAR_PREFIX}-spacer`,
  title: `${TOOLBAR_PREFIX}-title`,
  sortMenu: `${TOOLBAR_PREFIX}-sortMenu`,
  sticky: `${TOOLBAR_PREFIX}-sticky`,
  closeIcon: `${TOOLBAR_PREFIX}-closeIcon`,
  divider: `${TOOLBAR_PREFIX}-divider`,
  menuButton: `${TOOLBAR_PREFIX}-menuButton`,
  appBarLogo: `${TOOLBAR_PREFIX}-appBarLogo`,
  filterChip: `${TOOLBAR_PREFIX}-filterChip`,
  hidden: `${TOOLBAR_PREFIX}-hidden`,
};

const ToolbarRoot = styled('div')(({ theme }) => ({
  [`& .${toolbarClasses.root}`]: {
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    minHeight: 62,
  },
  [`& .${toolbarClasses.highlight}`]: {
    color: theme.palette.saveBar.text,
    backgroundColor: theme.palette.saveBar.background,
  },
  [`& .${toolbarClasses.actionBar}`]: {
    position: 'fixed',
    display: 'flex',
    justifyContent: 'space-between',
    zIndex: 2000,
    top: 0,
    left: 0,
    right: 0,
    padding: '0 40px 0 calc(240px + 52px)',
    minHeight: 64,
    [theme.breakpoints.down('sm')]: {
      padding: '0 8px 0 8px',
      minHeight: 56,
      '& .actionbar-text': {
        fontSize: '0.85rem',
      },
    },
  },
  [`& .${toolbarClasses.actions}`]: {
    color: theme.palette.text.secondary,
    position: 'relative',
    marginRight: 8,
    [theme.breakpoints.down('sm')]: {
      marginRight: 0,
      display: 'flex',
      justifyContent: 'flex-end',
    },
  },
  [`& .${toolbarClasses.spacer}`]: {
    flex: '1 1',
  },
  // 8px on top of the toolbar's own gutter = 16px. The search variant only looked inset
  // because its magnifier adornment fakes the gap
  [`& .${toolbarClasses.title}`]: {
    display: 'flex',
    flex: '1 auto',
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
      flex: '1 1 auto',
    },
  },
  [`& .${toolbarClasses.sortMenu}`]: {
    margin: '4px 0 0',
  },
  // no header offset: the main frame starts below the app bar
  [`& .${toolbarClasses.sticky}`]: {
    zIndex: 10,
    backgroundColor: theme.palette.background.paper,
    borderBottom: `solid 1px ${theme.palette.divider}`,
  },
  [`& .${toolbarClasses.closeIcon}`]: {
    cursor: 'pointer',
    padding: 12,
  },
  [`& .${toolbarClasses.divider}`]: {
    position: 'absolute',
    bottom: -1,
    left: 0,
    right: 0,
  },
  [`& .${toolbarClasses.menuButton}`]: {
    position: 'absolute',
    left: 12,
    display: 'none',
  },
  [`& .${toolbarClasses.appBarLogo}`]: {
    position: 'absolute',
    left: 0,
    width: 240,
    textAlign: 'center',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  [`& .${toolbarClasses.filterChip}`]: {
    marginRight: 4,
  },
}));

ItemsListToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};

// Inject toolbarClasses as 'classes' prop for backward compatibility
const OriginalItemsListToolbar = withTranslation()(ItemsListToolbar);
ItemsListToolbar = (props) => {
  // Der Wrapper ist eine Funktionskomponente, hier kommt das Theme also über
  // einen Hook herein. Die Klassenkomponente braucht es für die Logo-Wahl:
  // ein <img src> lässt sich nicht über eine CSS-Klasse umschalten.
  const theme = useTheme();

  return (
    <ToolbarRoot>
      <OriginalItemsListToolbar theme={theme} {...props} classes={toolbarClasses} />
    </ToolbarRoot>
  );
};








class ItemsList extends React.Component {
  listRef = null;
  itemRefs = [];
  boundings = null;
  lastItemHeight = 0;
  activeItem = null;
  routeBase = '';
  jumpToNextItem = false;
  delayTimeout = null;
  jumpToField = null;

  constructor(props) {
    super(props);
  
    window.restoreFieldsData = {};

    this.state = {
      data: props.data.slice(),
      query: '',
      order: localStorage.getItem('ly_order') ? localStorage.getItem('ly_order') : 'asc',
      orderBy: localStorage.getItem('ly_orderBy') ? localStorage.getItem('ly_orderBy') : 'title',
      filterGroup: props.allowGroupFiltering ? 'all' : null,
      // items whose field list is narrowed to fields with broken markup (theme, via the item menu)
      markupFilterItems: {},
      selected: [],
      changed: [],
      expanded: [],
      page: 0,
      rowsPerPage: localStorage.getItem('ly_rowsPerPage') ? parseInt(localStorage.getItem('ly_rowsPerPage')) : 10,
      blockingPromptOpen: false,
      // 'counting' | 'translating' | null, reported by the translate bar
      bulkTranslationPhase: null,
      lastLocation: null,
      confirmedNavigation: false,
      isPending: false,
      isSubfieldsPending: false,
      isSaving: false,
      forceUpdate: false,
      forceOpen: false,
      anchorEl: null,
      triggerClearAllTranslations: false,
      fieldOrderBy: localStorage.getItem('ly_fieldOrderBy') ? localStorage.getItem('ly_fieldOrderBy') : null,
      fieldOrder: localStorage.getItem('ly_fieldOrder') ? localStorage.getItem('ly_fieldOrder') : 'asc',
      fieldSortToken: 0,
      sortToken: 0,
      triggerDiscardChanges: false,
      scrollToIndex: -1,
      disabled: false,
      disabledInfo: '',
      saveErrorsExpanded: false,
    };   
    
    /*
    props.data.forEach((item) => {
      if(!item.progress) {
        this.calcFieldsProgress(item.id, item.fields, true);
      }
    })
    */
  }

  componentDidMount() {
    //debugger;
    // Deeplinking
    let uriParts = this.props.location.pathname.split('/');
    let id = uriParts[3] ? uriParts[3] : uriParts[2];
    if(id) {
      this.calcSetPage(isNaN(id) ? id : parseInt(id));


      /*
      // When loadMoreButton is used, and there is a deeplinked open Item, and if the data array is empty,
      // add an dummy item
      if(this.props.data.length === 0 && this.props.onLoadMore) {
        alert('####')
      }
      */

      setTimeout(() => {
        this.handleOpenItem(null, isNaN(id) ? id : parseInt(id))
      }, 0);

      // Jump to field
      let hash = window.location.hash.substring(1);
      this.jumpToField = hash ? hash : null;
    }

    // Scroll calc
    this.initialScrollTop = document.getElementById('mainFrame').scrollTop;

    // Check bulk translation tasks on mount
    this.checkBulkTranslationTasks();
  }

  checkBulkTranslationTasks() {
    const editLanguageCode = this.props.languages.languages.find(x => x.id == this.props.editLanguage)?.code;
    let shouldDisable = false;
    if (this.props.bulkTranslationTasks) {
      for (const [taskKey, task] of Object.entries(this.props.bulkTranslationTasks)) {
        // Finished tasks stay in the store until they are cleared — they must not lock the section.
        if (BULK_TASK_FINISHED_STATES.includes(task?.status)) continue;
        const taskData = taskKey.substring(taskKey.lastIndexOf(':') + 1);
        const [language, sectionsStr] = taskData.split('_');
        const sections = sectionsStr?.toLowerCase().split(',');
        if (language.toLowerCase() === editLanguageCode?.toLowerCase() && sections?.includes(this.props.type.toLowerCase())) {
          shouldDisable = true;
          break;
        }
      }
    }
    // Only update state if it actually changed
    if (shouldDisable && !this.state.disabled) {
      this.setState({
        disabled: true,
        disabledInfo: 'This section can\'t be edited until its bulk process is finished.'
      });
    } else if (!shouldDisable && this.state.disabled) {
      this.setState({
        disabled: false,
        disabledInfo: null
      });
    }
  }

  componentWillUnmount() {
    localStorage.removeItem('importFromOriginalNotAskAgain');
    this.closeSaveErrorSnackbar();
    this.props.setUnsavedEdits(false);
  }

  // the parent may need to know about unsaved edits, e.g. to lock a control that rebuilds the list
  reportUnsaved = (prevSelected) => {
    if(this.props.onUnsavedChange && prevSelected !== this.state.selected) {
      this.props.onUnsavedChange(this.state.selected.length);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    this.reportUnsaved(prevState.selected);
    // The app bar's switch warning needs to know about edits only this list holds
    if((prevState.selected.length > 0) !== (this.state.selected.length > 0)) {
      this.props.setUnsavedEdits(this.state.selected.length > 0);
    }

    // Check if current section is used by a bulk translation task
    // Always check since reference comparison may not catch all task changes
    this.checkBulkTranslationTasks();

    const locationChanged = this.props.location !== prevProps.location;
    const pathnameChanged = this.props.location.pathname !== prevProps.location.pathname;
    const extraRouteSegmentChanged = this.props.extraRouteSegment !== prevProps.extraRouteSegment;
    const uriParts = this.props.location.pathname.split('/');
    const id = uriParts[3] ? uriParts[3] : uriParts[2];

    const wasSaving = prevProps.isSaving;
    const isSaving = this.props.isSaving;

    // Deeplinking
    if(pathnameChanged) {
      if(id) {
        this.calcSetPage(isNaN(id) ? id : parseInt(id));
        setTimeout(() => this.handleOpenItem(null, isNaN(id) ? id : parseInt(id)), 0);
      } else {
        this.setState({ expanded: [] });
      }
    }
    if(extraRouteSegmentChanged) {
      if(uriParts[1] === this.props.type) {
        // Navigate to parent level when closing sections
        // /apps/freegifts/customize → /apps/freegifts
        // /apps → /apps (no change if already at base)
        if(this.props.extraRouteSegment) {
          this.props.history.push(`/${this.props.type}/${this.props.extraRouteSegment}`)
        } else {
          this.props.history.push(`/${this.props.type}`)
        }
        this.setState({ expanded: [] });

        if(window.mainFrameRef) {
          window.mainFrameRef.scroll({top: 0, behavior: 'smooth' });        
        }
      }
    }

    // Sort and Paginate after item was saved
    if(wasSaving === true && isSaving === false) {
      if(id) {
        this.calcSetPage(isNaN(id) ? id : parseInt(id));
      }
    }
  }

  // fields the backend answered with a corrected value: copy it into the list's own copy
  applyAdjustedValues = (incoming) => {
    if(!Array.isArray(incoming) || this.state.data.length === 0) return;
    // runs on every props change: one linear pass finds the (usually zero) adjusted fields, the
    // item and field lookups below happen only for those
    const adjusted = new Map();
    incoming.forEach(item => (item.fields || []).forEach(field => {
      if(hasAdjustedValue(field)) adjusted.set(`${item.id}/${field.id}`, field);
    }));
    if(adjusted.size === 0) return;
    let changed = false;
    const newData = this.state.data.map(item => {
      if(!item.fields) return item;
      let itemChanged = false;
      const fields = item.fields.map(field => {
        const incomingField = adjusted.get(`${item.id}/${field.id}`);
        if(!incomingField || incomingField.target === field.target) return field;
        itemChanged = true;
        return { ...field, target: incomingField.target, errors: incomingField.errors };
      });
      if(!itemChanged) return item;
      changed = true;
      return { ...item, fields };
    });
    if(changed) this.setState({ data: newData });
  }

  componentWillReceiveProps(newProps) {
    const wasPending = this.props.isPending;
    const isPending = newProps.isPending;

    const wasRemoving = this.props.isRemoving;
    const isRemoving = newProps.isRemoving;

    const wasSubfieldsPending = this.props.isSubfieldsPending;
    const isSubfieldsPending = newProps.isSubfieldsPending;

    const wasSubfieldsRemoving = this.props.isSubfieldsRemoving;
    const isSubfieldsRemoving = newProps.isSubfieldsRemoving;

    const wasSaving = this.props.isSaving;
    const isSaving = newProps.isSaving;

    const wasDisabled = this.props.disabled;
    const isDisabled = newProps.disabled;

    this.setState({isPending: isPending, isSubfieldsPending: isSubfieldsPending, isSaving: isSaving});

    // A value the backend corrected on save (a handle simplified to what Shopify accepts) is the
    // truth, not what was sent. The merges below only take incoming data on a pending or saving
    // transition, and the sections rebuild their data one render later - so the corrected value
    // would never arrive. Applied here on every props change, for those fields alone.
    this.applyAdjustedValues(newProps.data);

    // The run's overlay ends with the save. Has to run before the showOnlyFieldsList branch
    // returns: those sections hand over new data on the same tick the save flag falls, and the
    // overlay stayed up after any save longer than the fallback (seen on shop metafields)
    if(wasSaving === true && isSaving === false && this.state.bulkTranslationPhase === 'saving') {
      clearTimeout(this.bulkSavingFallback);
      this.setState({bulkTranslationPhase: null});
    }

    // Lets a page-level menu reach the same clear the per-item menu already offers.
    // Has to run before the showOnlyFieldsList branch returns
    if(this.props.triggerClearAll !== newProps.triggerClearAll) {
      this.handleClearAllTranslations();
    }

    // Handle showOnlyFieldsList mode: always sync props to state but preserve user edits
    if(this.props.showOnlyFieldsList && newProps.data !== this.props.data) {
      const newData = newProps.data.slice();

      // This branch returns before the shared "Save & Next" handling below, so a finished
      // save has to drop the pending edits here or the unsaved-changes bar never clears.
      // Opt-in, so callers that already handle their own post-save state keep it
      const savedSuccessfully = this.props.clearEditsOnSave === true
        && wasSaving === true && isSaving === false && !newProps.error;
      if(savedSuccessfully) {
        window.restoreFieldsData = {};
        this.setState({selected: []});
      }

      // Preserve user edits from window.restoreFieldsData
      if(!savedSuccessfully && newData.length > 0 && newData[0].fields) {
        newData[0].fields.forEach(field => {
          const editKey = `${newData[0].id}-${field.id}`;
          if(window.restoreFieldsData[editKey] !== undefined) {
            // Find the corresponding field in current state to get the edited value
            const currentStateData = this.state.data;
            if(currentStateData.length > 0 && currentStateData[0].fields) {
              const currentField = currentStateData[0].fields.find(f => f.id === field.id);
              if(currentField) {
                field.target = currentField.target;
              }
            }
          }
        });
      }

      this.setState({data: newData});
      return;
    }

    // Progressive batch: neue Einträge sichtbar machen während isPending noch true ist
    if(isPending === true && newProps.data.length > this.state.data.length) {
      this.setState({ data: newProps.data.slice() });
    }

    if((wasPending === true && isPending === false)
    || (wasSubfieldsPending === true && isSubfieldsPending === false)) {
      const newData = newProps.data.slice();
      const oldData = this.state.data;

      newData.forEach(newItem => {
        const oldItem = oldData.find(x => x.id == newItem.id);

        newItem.fields.forEach(newField => {
          if(newField.type === 'subfields') {

            if(oldItem) {
              newField.fields.forEach(newSubfield => {
                const oldSubfield = oldItem.fields.find(x => x.id == newField.id).fields.find(x => x.id == newSubfield.id);

                if(oldSubfield) {
                  // If the data has been saved just use the new data
                  if(!(wasSaving === true && isSaving === false)) {
                    newSubfield.target = oldSubfield.target;
                  }
                }
              });
            }
          } else {
            if(oldItem && oldItem.synchronized === true) {
              // If the data has been saved just use the new data. A field the backend adjusted
              // (a handle simplified to what Shopify accepts) always takes the incoming value:
              // the page rebuilds its data in its own willReceiveProps, so the second pass
              // arrives with the save flag already down and would keep the sent value forever
              if(!(wasSaving === true && isSaving === false) && !hasAdjustedValue(newField)) {
                const oldField = oldItem.fields.find(x => x.id == newField.id);
                if(oldField) {
                  newField.target = oldField.target;
                }
              }
            }
          }
        })

        //if(newItem.synchronized === true) {
        //  newItem.progress = this.calcFieldsProgress(newItem.id, newItem.fields, false);
        //}
      });

      this.setState({data:newData});
    }



    // Update the discard state if an item has been removed
    if(wasSubfieldsRemoving === true && isSubfieldsRemoving === false) {
      this.state.data.forEach(item => {
        item.fields.forEach(field => {
          if(field.type === 'subfields') {
            field.fields.forEach(subfield => {
              if(!newProps.data.find(x => x.id == item.id).fields.find(x => x.id == field.id).fields.find(x => x.id == subfield.id)) {
                delete window.restoreFieldsData[item.id + '-' + field.id + '-' + subfield.id];
              }
            })
          }
        })
      })
    }
    if(wasRemoving === true && isRemoving === false) {
      this.state.data.forEach(item => {
        item.fields.forEach(field => {
          if(!newProps.data.find(x => x.id == item.id).fields.find(x => x.id == field.id)) {
            delete window.restoreFieldsData[item.id + '-' + field.id];
          }
        })
      })
    }

    if((wasSubfieldsRemoving === true && isSubfieldsRemoving === false) || (wasRemoving === true && isRemoving === false)) {
      const newSelected = [];
      this.state.selected.forEach(item => {
        if((Object.keys(window.restoreFieldsData).find(x => x.startsWith(item + '-')))) {
          newSelected.push(item);
        }
      })
      this.setState({selected:newSelected});
    }

    // Save & Next
    if(wasSaving === true && isSaving === false) {

      if(!newProps.error) {
        // the save recomputed the row progresses and the fields' outdated state; those are
        // adopted here - the field values stay as they are, full adoption on a save edge is a
        // larger change. This write follows the merge above in the same tick, so it must carry
        // the flags itself or the merge's adoption is undone
        const withFresh = (fields, freshFields) => {
          let changed = false;
          const next = fields.map(field => {
            const fresh = (freshFields || []).find(x => x.id == field.id);
            if(!fresh) return field;
            if(field.type === 'subfields' && fresh.fields) {
              const sub = withFresh(field.fields || [], fresh.fields);
              if(sub !== field.fields) { changed = true; return {...field, fields: sub}; }
              return field;
            }
            if((fresh.outdated === true) !== (field.outdated === true)) { changed = true; return {...field, outdated: fresh.outdated === true}; }
            return field;
          });
          return changed ? next : fields;
        };
        this.setState({
          selected: [],
          data: this.state.data.map(item => {
            const fresh = newProps.data.find(x => x.id == item.id);
            if(!fresh) return item;
            const fields = withFresh(item.fields || [], fresh.fields);
            if(fresh.progress === item.progress && fields === item.fields) return item;
            return {...item, progress: fresh.progress, fields};
          }),
        });
      }
      if(this.jumpToNextItem) {
        const lastIndex = this.state.data.findIndex(x => x.id == this.jumpToNextItem);
        if(lastIndex+1 < this.state.data.length) {
          const nextId = this.state.data[lastIndex+1].id;
          this.jumpToNextItem = false;
          this.calcSetPage(nextId);
          setTimeout(() => this.handleOpenItem(null, nextId), 0);
        }
      }
    }

    // Error handling
    // wenn error.level 1 => collapse 
    if(this.props.error && this.props.error.level === 1) {
      if(newProps.error === false && !newProps.errorLockCollapse && this.state.expanded.length) {
        let path = this.props.location.pathname;
        this.props.history.push(path.substring(0, path.lastIndexOf('/')));
      }
    }




    // Nach dem Speichern, aus window.restoreFieldsData alle Einträge entfernen, deren Felder keine Errors haben
    if(wasSaving === true && isSaving === false) {
      // Read off the fields rather than off saveErrors: a rejected handle only ever shows up as
      // a field-level `errors` object, never in saveErrors, and its pre-edit value is the only
      // copy of the previous value there is
      const keysWithErrors = [];
      newProps.data.forEach(item => {
        (item.fields || []).forEach(field => {
          if(field.type === 'subfields') {
            (field.fields || []).forEach(subfield => {
              if(subfield.error || subfield.errors) {
                keysWithErrors.push(`${item.id}-${field.id}-${subfield.id}`);
              }
            })
          } else if(field.error || field.errors) {
            keysWithErrors.push(`${item.id}-${field.id}`);
          }
        })
      })

      Object.keys(window.restoreFieldsData).forEach(key => {
        if(keysWithErrors.indexOf(key) === -1) {
          delete window.restoreFieldsData[key];
        }
      })
    }


    // Save Infos
    if(newProps.saveInfos && newProps.saveInfos.length > 0 && _.isEqual(newProps.saveInfos, this.props.saveInfos) === false) {
      const saveInfos = newProps.saveInfos;
      const scope = this.props.type;
      const rawData = this.props.data;
      const history = this.props.history;
      this._saveSnackbarKeys = this._saveSnackbarKeys || [];
      this._saveSnackbarKeys.push(this.props.enqueueSnackbar('Errors occured', {
        variant: 'error',
        persist: true,
        content: (key) => (
          <SaveInfosList
            id={key}
            infos={saveInfos}
            scope={scope}
            rawData={rawData}
            history={history}
          />
        )
      }));
    }


    // Save Errors
    if(newProps.saveErrors && newProps.saveErrors.length > 0 && _.isEqual(newProps.saveErrors, this.props.saveErrors) === false) {
      const saveErrors = newProps.saveErrors;
      const scope = this.props.type;
      const rawData = this.props.data;
      const history = this.props.history;
      this._saveSnackbarKeys = this._saveSnackbarKeys || [];
      this._saveSnackbarKeys.push(this.props.enqueueSnackbar('Errors occured', {
        variant: 'error',
        persist: true,
        content: (key) => (
          <SaveErrorsList
            id={key}
            errors={saveErrors}
            scope={scope}
            rawData={rawData}
            history={history}
          />
        )
      }));
      // window.restoreFieldsData für alle saveErrors setzen
      let newSelected = [];
      newProps.saveErrors.forEach(item => {
        if(item.object) {
          newSelected.push(parseItemId(item.object));
          item.errors.forEach(error => {
            const itemId = parseItemId(item.object);
            const subfieldsId = error.object_subfieldsId ? '-' + error.object_subfieldsId : '';
            const restoreKey = itemId + subfieldsId + '-' + error.object_key;

            // Only write restoreValue once - on a second failed save `restore` already holds
            // the rejected value, so overwriting would offer that back instead of the original
            if(!(restoreKey in window.restoreFieldsData)) {
              let restoreValue = '';
              try {
                if(error.object_subfieldsId) {
                  restoreValue = newProps.data.find(x => x.id === itemId).fields.find(x => x.id === error.object_subfieldsId).fields.find(x => x.id === error.object_key).restore;
                } else {
                  restoreValue = newProps.data.find(x => x.id === itemId).fields.find(x => x.id === error.object_key).restore;
                }
              } catch(err) {
                console.log(err);
              }

              window.restoreFieldsData[restoreKey] = restoreValue || '';
            }
          })
        }
      })
      this.setState({selected:newSelected});
    }


    const currentLanguage = this.props.shop.shop.edit_language;
    const newLanguage = newProps.shop.shop.edit_language;
    if(currentLanguage != newLanguage) {
      document.getElementById('mainFrame').scroll({top: 0, behavior: 'smooth'});
    }


    /*
    console.log('#####', newProps.languages.languages, newProps.editLanguage, newProps.languages.languages.find(x => x.id == newProps.editLanguage).code)
    if(outOfSyncString) {
      let outOfSyncLanguages = outOfSyncString.split(';');
      let newOutOfSyncSections = {};
      outOfSyncLanguages.forEach(item => {
        if(item !== '') {
          let language = item.split('_')[0]
          let objects = item.split('_')[1].split(',');
          newOutOfSyncSections[language] = objects;
        }
      });

      this.setState({disabled: true});
    }
    */

    // Disabled
    //if(wasDisabled !== isDisabled) {
    //  this.setState({disabled: isDisabled});
    //}


  }

  setListRef = (ref) => {
    this.listRef = ref;
    if(ReactDOM.findDOMNode(this.listRef)) {
      this.boundings = ReactDOM.findDOMNode(this.listRef).getBoundingClientRect();
    }
  }

  // The order the user last asked for, captured from the whole list and applied to whatever
  // survives the filter - like the field sort inside a row. Retaken when the sort option changes,
  // on "Re-apply sort", and when items come or go (load, batches, deletions). A value change alone
  // never moves a row: sorting by the live progress sent the open item elsewhere, often onto
  // another page, when the sync on open or a save recomputed it
  sortedItems = (items) => {
    const { data, order, orderBy, sortToken } = this.state;
    const key = `${orderBy}|${order}|${sortToken}|${data.map(x => x.id).join(',')}`;
    if(!this.itemRanks || this.itemRanks.key !== key) {
      const ranks = {};
      stableSort(data, getSorting(order, orderBy)).forEach((item, index) => { ranks[item.id] = index; });
      this.itemRanks = { key, ranks };
    }
    return applyItemRanks(items, this.itemRanks.ranks);
  }

  calcSetPage = (id) => {
    const { data, query, rowsPerPage, filterGroup } = this.state;
    const { hideSorting } = this.props;
    let sortedArr = hideSorting ? filterItems(data, query, filterGroup, this.props.searchFieldLabels) : this.sortedItems(filterItems(data, query, filterGroup, this.props.searchFieldLabels))
    let itemIndex = sortedArr.findIndex(x => x.id == id);
    let pageNum = Math.floor(itemIndex / this.state.rowsPerPage);
    if(pageNum === -1) pageNum = 0;
    this.setState({ page: pageNum });
  }

  scrollToItem = (id, jump) => {
    const iel = document.getElementById(`list-item-${id}`);
    const mainFrame = document.getElementById('mainFrame');
    if(iel && mainFrame) {
      // the frame starts below the app bar, so the item's viewport position is taken relative
      // to the frame's own top; taken as viewport-absolute it overshot by the bar's height
      const itemTop = iel.getBoundingClientRect().top - mainFrame.getBoundingClientRect().top;
      const triggerHeight = jump ? 0 : 63;
      const paper = iel.closest('#ItemsList');
      const toolbarWrapper = paper?.firstElementChild;
      const toolbarHeight = toolbarWrapper ? toolbarWrapper.offsetHeight : 0;
      const offset = mainFrame.scrollTop + itemTop - toolbarHeight + triggerHeight + 1;
      mainFrame.scroll({top: offset, behavior: jump ? 'auto' : 'smooth' });
    }
  }

  scrollToField = (itemId, fieldId) => {
    const itemData = this.state.data.find(x => x.id === itemId);
    const field = itemData?.fields?.find(f => f.id == fieldId);
    this.setState({
      scrollToIndex: this._calcFieldIndex(itemId, fieldId),
      // a fresh object per request, so the same field can be asked for twice
      scrollToFieldRequest: field ? { id: field.id } : null,
    })
  }
  _calcFieldIndex = (itemId, fieldId) => {
    const itemData = this.state.data.find(x => x.id === itemId);
    let index = 0;
    if(itemData.fields) {
      for(let i=0; i < itemData.fields.length; i++) {
        let field = itemData.fields[i];
        if(field.id == fieldId) {
          index = i;
          break;
        }
      }
    }
    return index;
  }


  onItemExpand = (id) => {
    // An open item above collapses in the same 500ms as this one expands, pulling this header
    // up while a smooth scroll heads for its old position; the onEntered scroll then pulls back.
    // With an item collapsing above, that second scroll alone does the job
    if(!this.isCollapsingAbove(id)) this.scrollToItem(id);
    if(this.props.onExpand) {
      this.props.onExpand(id);
    }
  }

  onItemExpanded = (id) => {
    if(this.jumpToField) {
      const params = this.jumpToField.split(':');
      // Goto a field inside a list-item...
      if(params.length === 1)
        this.scrollToField(id, params[0]);
      // ...or goto a field inside a "subfields" field...
      if(params.length > 1) {
        //alert(`Open field: ${params[1]} in subfield: ${params[0]}`)
        this._openSubfields(params[0], params[1]);
      }
    } 
    // ...or goto a list-item
    else {
      this.scrollToItem(id);
    }
    if(this.props.onExpanded) {
      this.props.onExpanded(id);
    }
  }

  isCollapsingAbove = (id) => {
    if(!this.collapsingItemId || this.collapsingItemId === id) return false;
    const collapsing = document.getElementById(`list-item-${this.collapsingItemId}`);
    const expanding = document.getElementById(`list-item-${id}`);
    return Boolean(collapsing && expanding && (collapsing.compareDocumentPosition(expanding) & Node.DOCUMENT_POSITION_FOLLOWING));
  }

  onItemCollapse = (id) => {
    this.collapsingItemId = id;
    const uriParts = this.props.location.pathname.split('/');
    if(!uriParts[2]) {
      this.scrollToItem(id, true);
    }
    if(this.props.onCollapse) {
      this.props.onCollapse(id);
    }
  }

  onItemCollapsed = (id) => {
    if(this.collapsingItemId === id) this.collapsingItemId = null;
    if(this.props.onCollapsed) {
      this.props.onCollapsed(id);
    }
  }

  onExpandCollapsableFields = (type, id) => {
    if(this.props.onExpandCollapsableFields) {
      this.props.onExpandCollapsableFields(type, id);
    }
  }


  onFieldSelected = (itemId, fieldId) => {
    //this.scrollToField(itemId, fieldId);
  }

  onSubfieldSelected = (itemId, fieldId, subfieldId) => {
    
  }

  onSubfieldsExpand = (subfieldsElem) => {
    var rect = subfieldsElem.getBoundingClientRect();
    const paginationHeight = this.props.pagination ? 56 : 0;
    var offset = document.getElementById('mainFrame').scrollTop + rect.top - 128 - 44;
    window.mainFrameRef.scroll({top: offset, behavior: 'smooth' });     
  }

  onSubfieldsExpanded = (subfieldsElem) => {
    //console.log(subfieldsElem)
  }

  onSubfieldsCollapsed = (subfieldsElem) => {
    //console.log(subfieldsElem)
  }

  _openSubfields = (subfieldId, fieldId) => {
    
    // force update 
    this.setState({
      forceUpdate: true,
      forceOpen: subfieldId
    }, () => {
      this.setState({
        forceUpdate: false 
      });      
    });
  }




  handleClick = (event, id) => {
    const { selected } = this.state;
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }
    this.setState({ selected: newSelected });
  };

  handleOpenItem = (event, id) => {
    const { expanded } = this.state;
    const expandedIndex = expanded.indexOf(id);
    let newExpanded = [];

    if(event && event.target.type === 'checkbox') {
      let isExpanded = expanded.includes(id);
      let isSelected = !this.state.selected.includes(id);
      if(isExpanded || !isSelected) {
        return;
      }
    }

    if (expanded[0] === id) {
      newExpanded = [];
    } else {
      newExpanded = [id];
    }

    //console.log('handleOpenItem:', new Date().getTime(), id);

    this.setState({ expanded: newExpanded });
  };

  handleChangePage = (event, page) => {
    this.setState({ page });
    const mainFrame = document.getElementById('mainFrame');
    if(mainFrame && this.boundings) {
      mainFrame.scroll({top: this.boundings.top - 63, behavior: 'smooth' })
    }
  };

  handleChangeRowsPerPage = event => {
    localStorage.setItem('ly_rowsPerPage', event.target.value)
    this.setState({
      page: 0,
      rowsPerPage: event.target.value
    });
  };

  handleChangeText = (event, data, id) => {
    let itemData = null;
    let newData = this.state.data.slice();
    // Both error channels are cleared here: the message and the marking describe the value that
    // was rejected, so editing or restoring the field leaves nothing for them to describe
    if(data.parentField) {
      newData.find(x => x.id === id).fields.find(x => x.id === data.parentField).fields.filter(x => x.id === data.id).forEach(x => {
        x.target = data.target;
        x.error = data.error;
        x.errors = false;
      });
    } else {
      const field = newData.find(x => x.id === id).fields.find(x => x.id === data.id);
      field.target = data.target;
      field.error = data.error;
      field.errors = false;
    }

    // functional updates: a machine translation run reports many fields in one tick, and updates
    // computed from this.state clobbered each other (an item dropped out of the selection while
    // its fields still held edits, and the run's save then had nothing to save)
    if(!this.state.selected.includes(id)) {
      this.setState(prev => prev.selected.includes(id) ? null : { selected: [...prev.selected, id] });
    }

    const parentId = data.parentField ? '-'+data.parentField : '';
    if(!window.restoreFieldsData[`${id}${parentId}-${data.id}`] && window.restoreFieldsData[`${id}${parentId}-${data.id}`] !== '') {
      window.restoreFieldsData[`${id}${parentId}-${data.id}`] = data.initial || '';
    } else if(window.restoreFieldsData[`${id}${parentId}-${data.id}`] === data.target) {
      delete window.restoreFieldsData[`${id}${parentId}-${data.id}`];
      if(Object.keys(window.restoreFieldsData).filter(x => x.indexOf(`${id}-`) !== -1).length == 0) {
        this.setState(prev => ({ selected: prev.selected.filter(item => item !== id) }));
      }
    }

    this.setState({ data: newData });
  };

  // A restore key is `${itemId}-${fieldId}` or `${itemId}-${parentFieldId}-${fieldId}`, but ids
  // carry dashes themselves (alt-123, section-product, 123-chart-0), so the key is matched against
  // the real ids instead of being split on dashes. Null for a key that fits nothing
  resolveRestoreKey = (key, data) => {
    const item = data
      .filter(x => key.startsWith(`${x.id}-`))
      .sort((a, b) => String(b.id).length - String(a.id).length)[0];
    if(!item || !item.fields) return null;
    const rest = key.slice(String(item.id).length + 1);
    const field = item.fields.find(x => String(x.id) === rest);
    if(field) return field;
    for(const parent of item.fields) {
      if(parent.fields && rest.startsWith(`${parent.id}-`)) {
        const subfield = parent.fields.find(x => String(x.id) === rest.slice(String(parent.id).length + 1));
        if(subfield) return subfield;
      }
    }
    return null;
  }

  handleDiscardChanges = (event) => {
    let newData = this.state.data.slice();
    Object.keys(window.restoreFieldsData).forEach((key) => {
      const field = this.resolveRestoreKey(key, newData);
      if(!field) return;
      field.target = window.restoreFieldsData[key];
      if(field.errors) {
        delete field.errors;
      }
    });
    // force update 
    this.setState({
      triggerDiscardChanges: !this.state.triggerDiscardChanges,
      data: newData,
      selected: [],
    });

    setTimeout(() => {
      window.restoreFieldsData = {}
    }, 100);
  }

  calcFieldsProgress = (id, fields, setState) => {
    let progress = 0;
    let fieldsNum = fields.reduce((n, x) => n + (x.type != 'subfields'), 0);
    let emptyNum = fields.reduce((n, x) => n + (x.target === '' && x.type != 'subfields'), 0);
    fields.map(field => {
      if(field.type === 'subfields' && field.id != 'seofields' && field.id != 'metafields' && field.id != 'variant_metafields' && field.id != 'images') {
        fieldsNum += field.fields.reduce((n, x) => n + (x.type != 'subfields'), 0);
        emptyNum += field.fields.reduce((n, x) => n + (x.target === '' && x.type != 'subfields'), 0);
      }
    });
    if(fieldsNum > 0) {
      progress = (1 - emptyNum / fieldsNum) * 100;
    } else {
      progress = 'empty';
    }
    if(setState) {
      let newData = this.state.data.slice();
      newData.find(x => x.id == id).progress = progress;
      this.setState({data: newData});      
    }
    return progress;
  }

  handleClearAllTranslations = () => {
    this.setState({
      query: '',
      triggerClearAllTranslations: !this.state.triggerClearAllTranslations
    })
  }

  // pinnedLanguage is set only by a machine-translation run: the words were spent for that
  // language, so its save must not follow a selector the merchant moved in the meantime
  // runItemId: the item a machine translation run just wrote, from the field list's save call. It
  // is saved whether or not it counts as edited: a result equal to a text the merchant had deleted
  // reads as a reverted edit and drops the item from the selection, and the run's save then went
  // out empty - the translation lived in the view only, the bar stayed and Discard emptied the field
  handleSave = (nextId, pinnedLanguage, confirmedFieldIds = [], runItemId = null) => {
    // a section a bulk run holds is never written, whatever the layer let through
    if(this.state.disabled) return;
    // Save & Next
    if(nextId) {
      this.jumpToNextItem = nextId;
    }

    const runItem = runItemId !== null && confirmedFieldIds.length > 0 ? runItemId : null;
    if(runItem !== null && !this.state.selected.includes(runItem)) {
      this.setState(prev => prev.selected.includes(runItem) ? null : { selected: [...prev.selected, runItem] });
    }
    const selectedItems = this.state.data.filter(item => this.state.selected.includes(item.id) || item.id == runItem);

    // Remove the synchronized flag for all items that are going to be saved
    let newData = this.state.data.slice();
    selectedItems.forEach((item, key) => {
      newData.find(x => x.id == item.id).synchronized = false
    })
    this.setState({
      data: newData
    });

    /*
    // TODO: Remove only the items from the this.restoreFieldData object, that have no matching entry in the this.props.saveErrors
    Object.keys(window.restoreFieldsData).forEach((key, i) => {
      const ids = key.split('-');
      const itemId = ids[0];
      const fieldId = ids[1];

      let isInSaveErrors = null;
      try {
        isInSaveErrors = this.props.saveErrors.find(x => x.object.split('/')[x.object.split('/').length-1] == itemId).errors.find(y => y.object_key == fieldId).length === 1; 
      }
      catch {
        isInSaveErrors = false;
      }
      finally {
        if(!isInSaveErrors) {
          console.log(window.restoreFieldsData[`${itemId}-${fieldId}`])
          //delete window.restoreFieldsData[`${itemId}-${fieldId}`];
        }
      }
    });
    */
    let selectedFields = {...window.restoreFieldsData};
    //console.log(window.restoreFieldsData)
    //window.restoreFieldsData = {};

    this.closeSaveErrorSnackbar();

    this.props.onSave(selectedItems, selectedFields, pinnedLanguage, confirmedFieldIds);
  }

  // "Keep translation" from a field menu: the field goes out as confirmed through the normal
  // save, alongside the item's pending edits - the same save the button would make
  handleKeepTranslation = (itemId, fieldId) => {
    const selected = this.state.selected.includes(itemId) ? this.state.selected : [...this.state.selected, itemId];
    this.setState({ selected }, () => this.handleSave(null, undefined, [fieldId]));
  }

  handleQueryChange = (event) => {
    this.setState({ 
      query: event.target.value,
      page: 0,
    })
  }

  handleFilterGroup = (group) => {
    //alert(group);
    this.setState({ 
      filterGroup: group,
      page: 0,
    });
  }

  // orders the entries inside each section, not the sections themselves. The token makes
  // re-picking the same option re-apply it, since the order is only captured on change
  handleSortFields = (field, order) => {
    localStorage.setItem('ly_fieldOrderBy', field);
    localStorage.setItem('ly_fieldOrder', order);
    this.setState(prev => ({
      fieldOrderBy: field,
      fieldOrder: order,
      fieldSortToken: prev.fieldSortToken + 1,
    }));
  }

  // the persisted choice may only reach lists that also carry the menu - anywhere else it
  // would reorder the entries with no control to switch back
  getFieldSort = () => {
    if(!this.props.sortFields || this.props.filterModules || !this.state.fieldOrderBy) {
      return null;
    }
    // persisted from a section with the outdated flag: elsewhere the flag does not exist
    if(this.state.fieldOrderBy === 'outdated' && this.props.flagsOutdated !== true) {
      return null;
    }
    return {by: this.state.fieldOrderBy, order: this.state.fieldOrder, token: this.state.fieldSortToken};
  }

  // re-captures the order on demand, for when edits have left it stale
  handleReapplyFieldSort = () => {
    this.setState(prev => ({ fieldSortToken: prev.fieldSortToken + 1 }));
  }

  // null is the order the API returned, which none of the sort options can express
  handleResetFieldSort = () => {
    localStorage.removeItem('ly_fieldOrderBy');
    localStorage.removeItem('ly_fieldOrder');
    this.setState({ fieldOrderBy: null, fieldOrder: 'asc' });
  }

  handleSort = (field, order) => {
    localStorage.setItem('ly_orderBy', field);
    localStorage.setItem('ly_order', order);
    this.setState({
      orderBy: field,
      order: order,
      page: 0,
    }, this.followExpandedItem);
  }

  // re-captures the order on demand, for when syncs and saves have left it stale
  handleReapplySort = () => {
    this.setState(prev => ({ sortToken: prev.sortToken + 1, page: 0 }), this.followExpandedItem);
  }

  // after a reorder, page and scroll follow the open item
  followExpandedItem = () => {
    const { data, query, rowsPerPage, filterGroup } = this.state;
    if(this.state.expanded.length > 0) {
      let sortedArr = this.sortedItems(filterItems(data, query, filterGroup, this.props.searchFieldLabels))
      let itemIndex = sortedArr.findIndex(x => x.id == this.state.expanded[0]);
      let pageNum = Math.floor(itemIndex / rowsPerPage);
      if(pageNum === -1) pageNum = 0;
      this.setState({ page: pageNum }, () => {
        this.scrollToItem(this.state.expanded[0]);
      });
    }
  }

  // the item menu's markup filter: narrows the field list to broken fields; with none to show it
  // says so instead of leaving an empty list behind
  toggleMarkupFilter = (item) => {
    if(this.state.markupFilterItems[item.id]) {
      this.setState({ markupFilterItems: { ...this.state.markupFilterItems, [item.id]: false } });
      return;
    }
    const broken = (item.fields || []).filter(field => field.type === 'text' && markupIssues(field.source, field.target) !== null).length;
    if(broken === 0) {
      this.props.enqueueSnackbar(this.props.t('itemsList.noMarkupProblems'), { variant: 'success', autoHideDuration: 4000 });
      return;
    }
    this.setState({ markupFilterItems: { ...this.state.markupFilterItems, [item.id]: true } });
  }

  handleOptionsMenuClick = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  // the item's Shopify admin page, through the store's legacy admin path - Shopify redirects it to
  // the current admin. Sections whose items have no page of their own get no entry
  // menus, themes, custom content and metafields get no link: their items are not admin pages of their own
  shopifyAdminUrl = (item) => {
    // a section may hand the link in (metaobjects: the entry page under its definition type)
    if(item.admin_url) return item.admin_url;
    const paths = { products: 'products', collections: 'collections', pages: 'pages', blogs: 'blogs', articles: 'articles' };
    const path = paths[this.props.type];
    const shopUrl = this.props.shop?.shop?.url;
    if(!path || !shopUrl || item.shopify_id === undefined || item.shopify_id === null) return null;
    const id = String(item.shopify_id).split('/').pop();
    return /^\d+$/.test(id) ? `https://${shopUrl}/admin/${path}/${id}` : null;
  }

  // the id chip copies the bare Shopify id; inside the header link, so the click must not open
  // or close the item
  copyShopifyId = (event, itemId, shopifyId) => {
    event.preventDefault();
    event.stopPropagation();
    if(navigator.clipboard) navigator.clipboard.writeText(String(shopifyId)).catch(() => {});
    clearTimeout(this.copiedTimer);
    this.setState({ copiedShopifyId: itemId });
    this.copiedTimer = setTimeout(() => this.setState({ copiedShopifyId: null }), 1500);
  }

  handleOptionsMenuClose = () => {
    this.setState({ anchorEl: null });
  };

  closeSaveErrorSnackbar = () => {
    if (this._saveSnackbarKeys) {
      this._saveSnackbarKeys.forEach(key => this.props.closeSnackbar(key));
      this._saveSnackbarKeys = [];
    }
  }

  shouldBlockNavigation = (nextLocation) => {
    const uriParts1 = this.props.location.pathname.split('/');
    const uriParts2 = nextLocation.pathname.split('/');
    return (uriParts1[1] === uriParts2[1]) ? false : true;
  }

  handleBlockedNavigation = (nextLocation) => {
    const {confirmedNavigation} = this.state
    const {shouldBlockNavigation} = this.props
    if (!confirmedNavigation && this.shouldBlockNavigation(nextLocation)){
      this.setState({
        blockingPromptOpen: true,
        lastLocation: nextLocation,
      });
      return false
    }
    return true
  }

  handleConfirmNavigationClick = () => this.handleCloseBlockingPromt(() => {
    const {history} = this.props
    const {lastLocation} = this.state
    if (lastLocation) {
       this.setState({
          confirmedNavigation: true
       }, () => {
          // Navigate to the previous blocked location with your navigate function     
          history.push(lastLocation.pathname)
       })
    }
  })

  handleCloseBlockingPromt = (callback) => {
    this.setState({blockingPromptOpen: false}, callback);
  }

  isSelected = id => this.state.selected.indexOf(id) !== -1;
  isExpanded = id => {
    return this.state.expanded.findIndex(function(item){ return item == id}) != -1;
  }
  getItemIdfromIndex = (arr, index) => {
    return arr[index].id
  }


  handleBulkTranslationRunChange = (phase) => {
    clearTimeout(this.bulkSavingFallback);
    this.setState({bulkTranslationPhase: phase || null});
    // 'saving' ends when the save's pending flag falls (componentWillReceiveProps); a save that
    // never starts - nothing to write - would leave the overlay up, so it also ends by itself
    if(phase === 'saving') {
      this.bulkSavingFallback = setTimeout(() => {
        if(this.state.bulkTranslationPhase === 'saving' && !this.props.isSaving) this.setState({bulkTranslationPhase: null});
      }, 1500);
    }
  }

  // One click on Translate is count -> translate -> save. This overlay covers all three, so the
  // page reads as busy throughout without a gap when the save's own overlay fades in, and
  // nothing typed meanwhile is overwritten when the translation lands.
  renderBulkTranslationOverlay = () => {
    const phase = this.state.bulkTranslationPhase;
    return (
      <LoadingIndicator
        pending={phase !== null}
        loadingType={phase || 'translating'}
      />
    );
  }

  guardReason = () => guardReason({
    translating: this.state.bulkTranslationPhase === 'translating',
    saving: this.props.isSaving === true,
    unsaved: this.state.selected.length > 0,
  })

  renderBlockingPrompt = () => {
    return (
      <React.Fragment>
        <Prompt
          when={this.guardReason() !== null}
          message={this.handleBlockedNavigation}
        />
        <ContextGuardDialog
          open={this.state.blockingPromptOpen === true}
          reason={this.guardReason()}
          action="leave"
          onCancel={() => this.handleCloseBlockingPromt(null)}
          onConfirm={this.handleConfirmNavigationClick}
        />
      </React.Fragment>
    );
  }

  renderPageSelect = ({ from, to, count }) => {
    const { t, classes } = this.props;
    const { rowsPerPage } = this.state;

    if (this.props.filterDisabled) {
      const { syncedCount, syncTotalCount } = this.props;

      return (
        <span style={{position: 'absolute', left: 24, top: '50%', transform: 'translateY(-50%)', margin: 0}}>
          {`${t('itemsList.showingItem')} ${from}–${to} ${t('itemsList.of')} ${count}`}
          {syncTotalCount > 0 &&
            <span className={classes.syncStatus}>
              {t('itemsList.syncingStatus', { synced: Math.min(syncedCount || 0, syncTotalCount), total: syncTotalCount })}
            </span>
          }
        </span>
      );
    }

    let pages = Math.ceil(count / rowsPerPage);
    // the stored page can outlive a filter or a shorter sync, and a value with no matching
    // option renders the select blank
    const selectedPage = Math.min(this.state.page, Math.max(0, pages - 1));
    let pageSelectItems = [];
    for(var a=1; a<=pages; a++) {
      pageSelectItems.push(<MenuItem id={`page-${a}`} key={`page-${a}`} value={a-1}>{a}</MenuItem>);
    }
    return (
      <FormControl
        component={'span'}
        id="ItemsList-pagination-pageselect">
        <span id="page-select-label">{t('itemsList.page')}: </span>
        <Select
          labelId="page-select-label"
          size="small"
          onChange={(e) => this.handleChangePage(e, e.target.value)}
          value={selectedPage}
          MenuProps={{
            PaperProps: { sx: { maxHeight: 360 } },
            classes: { paper: classes.menuPaper } 
          }}
          disableUnderline>
          {pageSelectItems}
        </Select>
        <span style={{position: 'absolute', left: 24, top: '50%', transform: 'translateY(-50%)', margin: 0}}>
          {`${t('itemsList.showingItem')} ${from}–${to} ${t('itemsList.of')} ${count !== -1 ? count : `${t('itemsList.moreThan')} ${to}`}`}
        </span>
      </FormControl>
    );
  }

  render() {
    const { t, isPending, isSticky, hideFilterbar, hideSorting, allowGroupFiltering, extraRouteSegment, virtualized, paginate, toolbarTitle, allowAutoTranslation, allowFieldFiltering, classes, itemsPrependList, loadMoreButton, useLazyloading, showOnlyFieldsList} = this.props;
    const { data, query, order, orderBy, selected, rowsPerPage, page, anchorEl, filterGroup, scrollToIndex } = this.state;

    const fromLanguageCode = this.props.languages.languages.find(x => x.base == true).code.toUpperCase();
    const toLanguageCode = this.props.languages.languages.find(x => x.id == this.props.shop.shop.edit_language).code.toUpperCase();

    // grouping is opt-in per item, so one grouped row switches the list to cards
    const isGrouped = data.some(item => item.groupId);
    let filteredData = filterItems(data, query, filterGroup, this.props.searchFieldLabels);
    let noFilterResults = false;
    let processedData = [];
    if(useLazyloading) {
      processedData = data;
    }
    else {
      processedData = paginateItems(
        hideSorting ? filteredData : this.sortedItems(filteredData),
        paginate,
        page,
        rowsPerPage
      )
      if(filteredData.length === 0) {
        filteredData = data;
        noFilterResults = true;
      }
    }

    // If showOnlyFieldsList is true, render only TranslationFields with toolbar but without wrapping components
    if (showOnlyFieldsList && data.length > 0 && data[0].fields) {
      // The built-in search box filters items, which in this mode is the single wrapping
      // item - so the fields themselves are what has to be matched against the query
      const fields = query
        ? data[0].fields.filter(field =>
            [field.label, field.source, field.target].some(value =>
              typeof value === 'string' && value.toLowerCase().indexOf(query.toLowerCase()) > -1
            )
          )
        : data[0].fields;

      // One long list of fields stops being usable past a few dozen, so page it. Clamped
      // because the page outlives a filter or a sync that returned fewer fields
      const pageCount = Math.max(1, Math.ceil(fields.length / rowsPerPage));
      const fieldPage = Math.min(page, pageCount - 1);

      // the "Showing x–y of n" row; below the list always, above it too with `pagination` (the
      // count is what a page of hundreds of metafields needs first, as on the products page)
      const fieldsPagination = () => (
        <TablePagination
          component="div"
          count={fields.length}
          rowsPerPageOptions={[10, 25, 50, 100]}
          rowsPerPage={rowsPerPage}
          page={fieldPage}
          backIconButtonProps={{'aria-label': t('itemsList.prevPage')}}
          nextIconButtonProps={{'aria-label': t('itemsList.nextPage')}}
          onPageChange={this.handleChangePage}
          onRowsPerPageChange={this.handleChangeRowsPerPage}
          labelRowsPerPage={t('itemsList.rowsPerPage')}
          labelDisplayedRows={this.renderPageSelect}
        />
      );

      return (
        <div id="ItemsList" className={classNames('fields-list-only')} ref={this.setListRef}>
          {this.renderBlockingPrompt()}
          {this.renderBulkTranslationOverlay()}

          {!this.props.hideFilterbar &&
            <React.Fragment>
              <ItemsListToolbar
                data={filteredData ? filteredData : null}
                searchFieldLabels={this.props.searchFieldLabels}
                numSelected={selected.length}
                deletable={this.props.deletable}
                onDelete={() => {this.props.onDelete(selected)}}
                onSave={() => this.handleSave(null)}
                onDiscard={() => this.handleDiscardChanges()}
                onQueryChange={this.handleQueryChange}
                onSort={this.handleSort}
                onReapply={this.handleReapplySort}
                hideFilterbar={hideFilterbar}
                hideSorting={hideSorting}
                allowGroupFiltering={allowGroupFiltering}
                onFilterGroup={this.handleFilterGroup}
                filterModules={this.props.filterModules}
                isSticky={isSticky}
                isPending={isPending}
                toolbarTitle={toolbarTitle}
                filterDisabled={this.props.filterDisabled}
                sortFields={this.props.sortFields}
                flagsOutdated={this.props.flagsOutdated}
                fieldSorting={this.getFieldSort() ? `${this.state.fieldOrderBy}${this.state.fieldOrder}` : null}
                onSortFields={this.handleSortFields}
                onReapplyFields={this.handleReapplyFieldSort}
                onResetFields={this.handleResetFieldSort}
              />
              <Divider />
            </React.Fragment>
          }

          {this.props.pagination && fields.length > 0 &&
            <React.Fragment>
              {fieldsPagination()}
              <Divider />
            </React.Fragment>
          }

          <TranslationFields
            key={data[0].id}
            itemId={data[0].id}
            data={fields}
            fieldsPerPage={rowsPerPage}
            fieldPage={fieldPage}
            virtualized={false}
            isPending={isPending}
            isSubfieldsPending={this.props.isSubfieldsPending}
            allowAutoTranslation={allowAutoTranslation}
            allowFieldFiltering={false}
            filterQuery={''}
            filterGroup={null}
            fieldSort={this.getFieldSort()}
            from={fromLanguageCode}
            to={toLanguageCode}
            toLanguageId={this.props.shop.shop.edit_language}
            isSaving={this.state.isSaving}
            forceUpdate={this.state.forceUpdate}
            triggerClearAllTranslations={this.state.triggerClearAllTranslations}
            triggerDiscardChanges={this.state.triggerDiscardChanges}
            scrollToIndex={scrollToIndex}
            scrollToFieldRequest={this.state.scrollToFieldRequest}
            nested={true}
            hideSourceToTargetMenu={this.props.hideSourceToTargetMenu}
            flagsOutdated={this.props.flagsOutdated}
            onKeepTranslation={(fieldId) => this.handleKeepTranslation(data[0].id, fieldId)}
            context={this.props.type}

            onSave={(nextId, pinnedLanguage, confirmedFieldIds) => this.handleSave(nextId, pinnedLanguage, confirmedFieldIds, data[0].id)}
            onDeleteItem={this.props.onDeleteItem}
            onDeleteTranslation={this.props.onDeleteTranslation}
            onAddItem={this.props.onAddItem}
            onChange={(event, field) => this.handleChangeText(event, field, data[0].id)}
            onExpandCollapsableFields={(type) => this.onExpandCollapsableFields(type, data[0].id)}
            onFieldSelected={this.onFieldSelected}
            onBulkTranslationRunChange={this.handleBulkTranslationRunChange}
            onSubfieldSelected={this.onSubfieldSelected}
            onSubfieldsExpand={this.onSubfieldsExpand}
            onSubfieldsExpanded={this.onSubfieldsExpanded}
            onSubfieldsCollapsed={this.onSubfieldsCollapsed}
            onTranslationModeChange={this.props.onTranslationModeChange}

            subfieldsPaginateFunc={this.props.subfieldsPaginateFunc}
          />

          {fields.length > 0 && fieldsPagination()}
        </div>
      );
    }

    // a closure, not a method: it reads a dozen locals destructured above
    const renderListItem = (n, i, a) => {
                  this.itemRefs[n.id] = React.createRef();
                  const isSelected = this.isSelected(n.id);
                  const isExpanded = this.isExpanded(n.id);

                  let uriParts = this.props.location.pathname.split('/');
                  let uri = extraRouteSegment ? `${extraRouteSegment}/${n.id}` : n.id;
                  let uriPrev = extraRouteSegment ? `${extraRouteSegment}/${i >= 1 ? this.getItemIdfromIndex(a, i-1) : false}` : `${i >= 1 ? this.getItemIdfromIndex(a, i-1) : false}`;
                  let uriNext = extraRouteSegment ? `${extraRouteSegment}/${i < a.length-1 ? this.getItemIdfromIndex(a, i+1) : false}` : `${i < a.length-1 ? this.getItemIdfromIndex(a, i+1) : false}`;

                  return (
                    <div className={classNames("ItemsList_list-item", isExpanded && 'expanded')}
                      key={`list-item-${n.id}`}
                      id={`list-item-${n.id}`}
                      ref={ref => this.itemRefs[n.id] = ref}
                      data-index={i}
                    >
                      <Sticky 
                        scrollElement="#mainFrame"  
                        boundaryElement={`#list-item-${n.id}`}
                        topOffset={0}
                        disabled={(!isExpanded || query !== '')}
                        hideOnBoundaryHit={true}
                        positionRecheckInterval={100}
                        stickyClassName={classNames('sticky', classes.stickyItem)}
                      >
                        {/*
                        <Checkbox
                          checked={this.isSelected(n.id)}
                          onChange={event => this.handleClick(event, n.id)}
                          style={{padding: '19px 24px', position: 'absolute', zIndex: 1}}
                        /> 
                        <Tooltip title="Save" className="inline-save-btn">
                          <Button aria-label="Save" variant="outlined" size="small" onClick={() => this.handleSave(null)}>
                            Save <SaveOutlinedIcon style={{marginLeft: 5}} />
                          </Button>
                        </Tooltip> 
                        */} 
                        <React.Fragment>
                          {isExpanded && 
                            <span className={'inline-actions'}>
                              {/* set per row, e.g. a help center link for that section */}
                              {n.headerAdornment}
                              <Link className={`${classes.linkReset} ly-plain-link`} to={uriPrev.indexOf('false')>=0 ? `/${uriParts[1]}/${uri}` : `/${uriParts[1]}/${uriPrev}`}> 
                                <IconButton
                                  disabled={uriPrev.indexOf('false')>=0}
                                  aria-label="Prev"
                                  variant="outlined"
                                  className="inline-save-btn"
                                  style={{marginLeft: 5, minWidth: 'unset'}}
                                  size="large">
                                  <ArrowBackOutlined className={classes.iconSmall} />
                                </IconButton>
                              </Link>
                              <Link className={`${classes.linkReset} ly-plain-link`} to={uriNext.indexOf('false')>=0 ? `/${uriParts[1]}/${uri}` : `/${uriParts[1]}/${uriNext}`}> 
                                <IconButton
                                  disabled={uriNext.indexOf('false')>=0}
                                  aria-label="Next"
                                  variant="outlined"
                                  className="inline-save-btn"
                                  style={{marginLeft: 5, minWidth: 'unset'}}
                                  size="large">
                                  <ArrowForwardOutlined className={classes.iconSmall} />
                                </IconButton>
                              </Link>
                              <span style={{position: 'relative'}}>
                                <IconButton
                                  style={{marginLeft: 5}}
                                  aria-owns={anchorEl ? 'options-menu' : undefined}
                                  aria-haspopup="true"
                                  aria-label="Options list"
                                  data-tour="items-options-btn"
                                  onClick={this.handleOptionsMenuClick}
                                  size="large">
                                  <MoreVertIcon />
                                </IconButton>
                                <Menu
                                  id="options-menu"
                                  anchorEl={anchorEl}
                                  open={Boolean(anchorEl)}
                                  onClose={this.handleOptionsMenuClose}
                                  disableAutoFocusItem
                                  style={{ top: 56, right: 0 }}
                                  anchorOrigin={{
                                    horizontal: 'right',
                                    vertical: 'top',
                                  }}
                                  transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                  }}
                                >
                                  {/* the item itself first, a divider, then what happens to its translations, the
                                      destructive entries last */}
                                  {this.shopifyAdminUrl(n) && <MenuItem component="a" href={this.shopifyAdminUrl(n)} target="_blank" rel="noopener noreferrer" onClick={this.handleOptionsMenuClose}><StorefrontOutlinedIcon style={{marginRight:'10px'}}/>{t('system.openInShopifyAdmin')}</MenuItem>}
                                  {this.props.onAddItem ? (<MenuItem onClick={() => {this.handleOptionsMenuClose(); this.props.onAddItem(n.id);}}><AddIcon style={{marginRight:'10px'}}/>{this.props.addItemLabel ? this.props.addItemLabel : t('system.addItem')}</MenuItem>) : null}
                                  {(this.shopifyAdminUrl(n) || this.props.onAddItem) && <Divider />}
                                  {this.props.onResaveAll ? (<MenuItem onClick={() => {this.handleOptionsMenuClose(); this.props.onResaveAll([n.id]);}}><ResaveIcon style={{marginRight:'10px'}}/>{t('system.resaveAll')}</MenuItem>) : null}
                                  {this.props.markupCheck && <MenuItem onClick={() => {this.handleOptionsMenuClose(); this.toggleMarkupFilter(n);}}><CodeOutlinedIcon style={{marginRight:'10px'}}/>{t(this.state.markupFilterItems[n.id] ? 'itemsList.showAllFields' : 'itemsList.showMarkupProblems')}</MenuItem>}
                                  <MenuItem onClick={() => {this.handleOptionsMenuClose(); this.handleClearAllTranslations();}}><ClearAllIcon style={{marginRight:'10px'}}/><Box component="span" sx={{color: 'error.main'}}>{t('system.clearAllTranslations')}</Box></MenuItem>
                                  {(this.props.onDeleteFields && n.fields && n.fields.length > 0) && <MenuItem onClick={() => {this.handleOptionsMenuClose(); this.setState({ deleteFieldsItemId: n.id });}}><DeleteSweepOutlinedIcon style={{marginRight:'10px'}}/>{t('itemsList.deleteFields')}<NewBadge sx={{ ml: 1 }} /></MenuItem>}
                                  {this.props.deletable && <MenuItem onClick={() => {this.handleOptionsMenuClose(); this.props.onDelete([n.id])}}><DeleteIcon style={{marginRight:'10px'}}/>{t('system.deleteSection')}</MenuItem>}
                                </Menu>
                                {this.state.deleteFieldsItemId === n.id &&
                                  <DeleteFieldsDialog
                                    itemTitle={n.title}
                                    fields={n.fields}
                                    onClose={() => this.setState({ deleteFieldsItemId: null })}
                                    onConfirm={(ids) => { this.setState({ deleteFieldsItemId: null }); this.props.onDeleteFields(n.id, ids); }}
                                  />
                                }
                              </span>
                              {/*(isExpanded && selected.length > 0) && 
                                <span>
                                  <Button aria-label="Save & Next" variant="outlined" size="small" onClick={() => this.handleSave(n.id)} className="inline-save-btn" style={{marginLeft: 5}}>
                                    Save & Next
                                  </Button>
                                </span>
                              */}       
                            </span> 
                          }

                          <Link className={`${classes.linkReset} ly-plain-link`} to={!isExpanded ? `/${uriParts[1]}/${uri}` : (extraRouteSegment ? `/${uriParts[1]}/${extraRouteSegment}` : `/${uriParts[1]}`)}>

                            <ListItem
                              // sub-items (a theme's custom templates) step in under their parent row
                              className={classNames(classes.listItemHeader, n.indent && classes.listItemHeaderIndented)}
                              // not isPending: a row still loading stays openable, it just shows
                              // its skeleton. Disabling it only reads as broken
                              disabled={this.state.isSaving}
                              button
                            >
                              <ListItemText inset
                                primary={
                                  <React.Fragment>
                                    {n.icon &&
                                      <span className={classes.itemIcon}>{n.icon}</span>
                                    }
                                    <span className={classes.itemTitle}>{n.title}</span>
                                    {n.isNew === true && <Chip label="NEW" size="small" classes={{root: classes.newBadge}} />}
                                    {typeof n.shopify_id !== "undefined" && (() => {
                                      const bareId = String(n.shopify_id).split('/').pop();
                                      return (
                                        <Tooltip title={this.state.copiedShopifyId === n.id ? t('system.copied') : t('system.copyShopifyId')} arrow>
                                          <Chip label={"#" + bareId} variant="outlined" size="small" classes={{root: classes.shopifyId}} onClick={(e) => this.copyShopifyId(e, n.id, bareId)} />
                                        </Tooltip>
                                      );
                                    })()}
                                    {this.isSelected(n.id) && <Chip label={t('itemsList.unsaved')} size="small" style={{fontWeight: 'normal !important', marginLeft: 12}} />}
                                  </React.Fragment>
                                }
                                primaryTypographyProps={{
                                  noWrap: true,
                                  // the open item keeps the focus, collapsed ones step back a little
                                  className: classNames(n.hasError ? classes.itemTitleError : null, isExpanded ? null : classes.itemTitleDimmed),
                                  style: {
                                    paddingRight: isExpanded ? 140 : 10,
                                    position: 'relative',
                                    bottom: n.subtitle ? '5px' : '0px',
                                  },
                                }}
                                secondary={<span>
                                  <ProgressIndicator progress={n.progress} outOfSync={n.out_of_sync === true}/>
                                  {n.hasError && <ErrorOutlineOutlinedIcon size={12} className={classes.itemErrorIcon} />}
                                </span>}
                                secondaryTypographyProps={{
                                  component: 'span',
                                  // the ring is anchored to the row, not the text, so it follows the indent by hand
                                  style: { position: 'absolute', top: 0, left: n.indent ? 24 : 0 }
                                }}
                              />
                              {n.subtitle ? (
                                  <span className={classNames(classes.itemSubtitle, n.icon && 'with-icon')}>{n.subtitle}</span>
                                ) : (
                                  null
                                )
                              }
                              {/*<ExpandLess className={classes.expandIcon} />*/}
                              {isExpanded ? null : <ExpandMore className={classes.expandIcon} />}      
                            </ListItem>  
                          </Link>         
                        </React.Fragment>    
                      </Sticky>
                      <Collapse 
                        in={isExpanded} 
                        timeout={500}
                        onEnter={() => this.onItemExpand(n.id)}
                        onEntered={() => this.onItemExpanded(n.id)}
                        onExit={() => this.onItemCollapse(n.id)}
                        onExited={() => this.onItemCollapsed(n.id)}
                        classes={{
                          wrapperInner: classes.collapseWrapperInner
                        }}
                        unmountOnExit
                      >
                        <div>
                        {(itemsPrependList && itemsPrependList[n.id]) &&
                          <div>{itemsPrependList[n.id]}</div>
                        }
                        <TranslationFields
                          key={n.id}
                          itemId={n.id}
                          data={n.fields}
                          virtualized={virtualized}
                          isPending={(this.state.isPending && !this.state.isSaving && !this.state.isSubfieldsPending) || (this.props.error && this.props.error.level === 1)}
                          showSkeletonSpinner={this.props.showSkeletonSpinner}
                          isSubfieldsPending={this.props.isSubfieldsPending}
                          allowAutoTranslation={allowAutoTranslation}
                          allowFieldFiltering={(allowFieldFiltering && !noFilterResults)}
                          filterQuery={(allowFieldFiltering && !noFilterResults) ? query : ''}
                          searchFieldLabels={this.props.searchFieldLabels}
                          fieldSort={this.getFieldSort()}
                          filterGroup={this.state.markupFilterItems[n.id] ? 'markup' : filterGroup}
                          from={fromLanguageCode}
                          to={toLanguageCode}
                          toLanguageId={this.props.shop.shop.edit_language}
                          isSaving={this.state.isSaving}
                          forceUpdate={this.state.forceUpdate}
                          forceOpen={this.state.forceOpen}
                          triggerClearAllTranslations={this.state.triggerClearAllTranslations}
                          triggerDiscardChanges={this.state.triggerDiscardChanges}
                          emptyMessage={n.emptyMessage}
                          scrollToIndex={scrollToIndex}
                          scrollToFieldRequest={this.state.scrollToFieldRequest}
                          hideSourceToTargetMenu={this.props.hideSourceToTargetMenu}
                          flagsOutdated={this.props.flagsOutdated}
                          onKeepTranslation={(fieldId) => this.handleKeepTranslation(n.id, fieldId)}
                          context={this.props.type}

                          onSave={(nextId, pinnedLanguage, confirmedFieldIds) => this.handleSave(nextId, pinnedLanguage, confirmedFieldIds, n.id)}
                          onDeleteItem={this.props.onDeleteItem}
                          onDeleteTranslation={this.props.onDeleteTranslation}
                          onAddItem={this.props.onAddItem}
                          onChange={(event, data) => this.handleChangeText(event, data, n.id)}
                          onExpandCollapsableFields={(type) => this.onExpandCollapsableFields(type, n.id)}
                          onFieldSelected={this.onFieldSelected}
                          onBulkTranslationRunChange={this.handleBulkTranslationRunChange}
                          onSubfieldSelected={this.onSubfieldSelected}
                          onSubfieldsExpand={this.onSubfieldsExpand}
                          onSubfieldsExpanded={this.onSubfieldsExpanded}
                          onSubfieldsCollapsed={this.onSubfieldsCollapsed}
                          onTranslationModeChange={this.props.onTranslationModeChange}

                          subfieldsPaginateFunc={this.props.subfieldsPaginateFunc}
                        />
                        </div>
                      </Collapse>
                      <Divider />
                    </div>
                  );
    };

    // a card is its shadow on this white page, and one shadow cannot span sibling
    // rows - so each group needs its own Paper
    const renderItemRows = (rows) => (
      <List component="div" dense={false} style={{padding: 0}}>
        {rows.map(({ item, index }) => renderListItem(item, index, processedData))}
      </List>
    );

    const renderItems = () => {
      const indexed = processedData.map((item, index) => ({ item, index }));
      if(!isGrouped) {
        return renderItemRows(indexed);
      }

      // contiguous runs of the same groupId, taken off the rows that rendered
      const groups = [];
      indexed.forEach(entry => {
        const groupId = entry.item.groupId ? entry.item.groupId : null;
        const current = groups[groups.length - 1];
        if(current && current.groupId === groupId) {
          current.rows.push(entry);
        } else {
          groups.push({ groupId: groupId, label: entry.item.groupLabel, info: entry.item.groupInfo, rows: [entry] });
        }
      });

      return groups.map((group, groupIndex) => (
        <Paper
          key={`list-group-${group.groupId ? group.groupId : groupIndex}`}
          className={classes.groupCard}
          elevation={3}
        >
          {group.label &&
            <React.Fragment>
              {/* groupActions: per group id, a control shown at the right end of the label row */}
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', paddingRight: 24 }}>
                <Typography variant="h6" component="h3" className={classes.groupLabel}>{group.label}</Typography>
                {this.props.groupActions && this.props.groupActions[group.groupId]}
              </div>
              {group.info &&
                <Typography variant="body2" color="text.secondary" className={classes.groupInfo}>{group.info}</Typography>
              }
              <Divider />
            </React.Fragment>
          }
          {renderItemRows(group.rows)}
        </Paper>
      ));
    };

    return (
      <React.Fragment>
        {this.renderBlockingPrompt()}
        {this.renderBulkTranslationOverlay()}
        {this.state.disabled &&
          <div style={{position: 'absolute', zIndex: 100, width: '100%', height: '100%', left: 0}}>
            {this.state.disabledInfo &&
              <Typography className={classNames('disabled-info', classes.disabledInfo)}>
                <ErrorOutlineIcon style={{ fontSize: '3rem', margin: '1rem'}}/><br/>
                {this.state.disabledInfo}
              </Typography>
            }
          </div>
        }
        {data.length > 0 ?

          <Paper id="ItemsList"
            ref={this.setListRef}
            className={classNames(
              classes.root,
              this.state.disabled ? 'disabled' : null,
              isGrouped && classes.groupedRoot,
            )}
            elevation={isGrouped ? 0 : 1}
          >
            <ItemsListToolbar
              data={filteredData ? filteredData : null}
              searchFieldLabels={this.props.searchFieldLabels}
              numSelected={selected.length}
              deletable={this.props.deletable}
              onDelete={() => {this.props.onDelete(selected)}}
              onSave={() => this.handleSave(null)}
              onDiscard={() => this.handleDiscardChanges()}
              onQueryChange={this.handleQueryChange}
              onSort={this.handleSort}
              onReapply={this.handleReapplySort}
              hideFilterbar={hideFilterbar}
              hideSorting={hideSorting}
              allowGroupFiltering={allowGroupFiltering}
              onFilterGroup={this.handleFilterGroup}
              filterModules={this.props.filterModules}
              isSticky={isSticky}
              isPending={isPending}
              toolbarTitle={toolbarTitle}
              filterDisabled={this.props.filterDisabled}
              sortFields={this.props.sortFields}
              flagsOutdated={this.props.flagsOutdated}
              fieldSorting={this.getFieldSort() ? `${this.state.fieldOrderBy}${this.state.fieldOrder}` : null}
              onSortFields={this.handleSortFields}
              onReapplyFields={this.handleReapplyFieldSort}
              onResetFields={this.handleResetFieldSort}
            />
            <Divider />
            <div className={classes.tableWrapper}>
              {noFilterResults &&
                <Paper className={classes.infoBox} elevation={0}>
                  <Typography variant="subtitle1" className={classes.infoText}><WarningOutlinedIcon style={{ fontSize: 24, marginTop: -2 }} /> {t('itemsList.noFilterResults')}</Typography>
                </Paper>
              }
              {this.props.pagination &&
                <React.Fragment>
                  {this.props.syncProgress !== undefined &&
                    <LinearProgress
                      variant={typeof this.props.syncProgress === 'number' ? 'determinate' : 'indeterminate'}
                      value={typeof this.props.syncProgress === 'number' ? this.props.syncProgress : undefined}
                    />
                  }
                  <TablePagination
                    component="div"
                    count={filteredData.length}
                    rowsPerPageOptions={[10, 25, 50, 100]}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    backIconButtonProps={{ 'aria-label': t('itemsList.prevPage') }}
                    nextIconButtonProps={{ 'aria-label': t('itemsList.nextPage') }}
                    onPageChange={this.handleChangePage}
                    onRowsPerPageChange={this.handleChangeRowsPerPage}
                    labelRowsPerPage={t('itemsList.rowsPerPage')}
                    //labelDisplayedRows={({ from, to, count }) => { return `${from}–${to} ${t('itemsList.of')} ${count !== -1 ? count : `${t('itemsList.moreThan')} ${to}`}`; }}
                    labelDisplayedRows={this.renderPageSelect}
                    //ActionsComponent={this.renderPaginationActionsComponent}
                  />
                  <Divider />                  
                </React.Fragment>
              }
              {renderItems()}
            </div>
            { this.props.pagination === false ? (
              null
              ) : (
              <TablePagination
                component="div"
                count={filteredData.length}
                rowsPerPageOptions={[10, 25, 50, 100]}
                rowsPerPage={rowsPerPage}
                page={page}
                backIconButtonProps={{'aria-label': t('itemsList.prevPage')}}
                nextIconButtonProps={{'aria-label': t('itemsList.nextPage')}}
                onPageChange={this.handleChangePage}
                onRowsPerPageChange={this.handleChangeRowsPerPage}
                labelRowsPerPage={t('itemsList.rowsPerPage')}
                //labelDisplayedRows={({ from, to, count }) => { return `${from}–${to} ${t('itemsList.of')} ${count !== -1 ? count : `${t('itemsList.moreThan')} ${to}`}`; }}
                labelDisplayedRows={this.renderPageSelect}
                //ActionsComponent={this.renderPaginationActionsComponent}
              />
            )}
          </Paper>
        :
          this.props.emptyMessage
        }
        {this.props.loadMoreButton && this.props.onLoadMore &&
          <Grid container justifyContent="center" direction="row" style={{padding: '24px 0'}}>
            <Button size="large" variant="contained" color="primary" onClick={this.props.onLoadMore}>
              Load more content...
            </Button>                
          </Grid>
        }
      </React.Fragment>
    );
  }
}

const ITEMS_PREFIX = 'ItemsList';
const ICON_COLUMN = 30; // small icon (20px) plus its gap to the title

const itemsClasses = {
  root: `${ITEMS_PREFIX}-root`,
  table: `${ITEMS_PREFIX}-table`,
  tableWrapper: `${ITEMS_PREFIX}-tableWrapper`,
  listItemWrapper: `${ITEMS_PREFIX}-listItemWrapper`,
  listItemHeader: `${ITEMS_PREFIX}-listItemHeader`,
  listItemHeaderIndented: `${ITEMS_PREFIX}-listItemHeaderIndented`,
  expandIcon: `${ITEMS_PREFIX}-expandIcon`,
  collapseWrapperInner: `${ITEMS_PREFIX}-collapseWrapperInner`,
  stickyItem: `${ITEMS_PREFIX}-stickyItem`,
  deleteBtn: `${ITEMS_PREFIX}-deleteBtn`,
  alertBtn: `${ITEMS_PREFIX}-alertBtn`,
  linkReset: `${ITEMS_PREFIX}-linkReset`,
  iconSmall: `${ITEMS_PREFIX}-iconSmall`,
  infoBox: `${ITEMS_PREFIX}-infoBox`,
  infoText: `${ITEMS_PREFIX}-infoText`,
  menuPaper: `${ITEMS_PREFIX}-menuPaper`,
  disabledInfo: `${ITEMS_PREFIX}-disabledInfo`,
  shopifyId: `${ITEMS_PREFIX}-shopifyId`,
  itemTitle: `${ITEMS_PREFIX}-itemTitle`,
  itemTitleDimmed: `${ITEMS_PREFIX}-itemTitleDimmed`,
  itemTitleError: `${ITEMS_PREFIX}-itemTitleError`,
  itemErrorIcon: `${ITEMS_PREFIX}-itemErrorIcon`,
  itemSubtitle: `${ITEMS_PREFIX}-itemSubtitle`,
  itemIcon: `${ITEMS_PREFIX}-itemIcon`,
  newBadge: `${ITEMS_PREFIX}-newBadge`,
  groupLabel: `${ITEMS_PREFIX}-groupLabel`,
  groupInfo: `${ITEMS_PREFIX}-groupInfo`,
  groupedRoot: `${ITEMS_PREFIX}-groupedRoot`,
  groupCard: `${ITEMS_PREFIX}-groupCard`,
  syncStatus: `${ITEMS_PREFIX}-syncStatus`,
};

// gap between the filter bar and the group cards, and between the cards themselves
const GROUP_GAP = 32;

const ItemsListRoot = styled('div')(({ theme }) => ({
  [`& .${itemsClasses.root}`]: {
    width: '100%',
    marginTop: 20,
  },
  [`& .${itemsClasses.table}`]: {
    minWidth: 1020,
  },
  [`& .${itemsClasses.tableWrapper}`]: {
    overflowX: 'auto',
  },
  [`& .${itemsClasses.listItemWrapper}`]: {
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'flex-start',
    flexDirection: 'column',
  },
  [`& .${itemsClasses.listItemHeader}`]: {
    height: 62,
    '& h3': {
      lineHeight: 1,
    },
    [theme.breakpoints.down('sm')]: {
      minHeight: 62,
      display: 'flex',
      alignItems: 'center',
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
    },
  },
  [`& .${itemsClasses.listItemHeaderIndented}`]: {
    paddingLeft: `calc(${theme.spacing(2)} + 24px)`,
    [theme.breakpoints.down('sm')]: {
      paddingLeft: `calc(${theme.spacing(1)} + 24px)`,
    },
  },
  [`& .${itemsClasses.expandIcon}`]: {
    marginRight: 4,
    opacity: .5,
  },
  [`& .${itemsClasses.collapseWrapperInner}`]: {
    backgroundColor: `${theme.palette.surfaceRecessed} !important`,
  },
  [`& .${itemsClasses.stickyItem}`]: {
    zIndex: 11,
    width: '100%',
    minHeight: 62,
    height: 62,
    backgroundColor: theme.palette.background.paper,
    [theme.breakpoints.down('sm')]: {
      '& .inline-actions': {
        right: '2px',
        top: '10px',
      },
      '& .inline-actions .MuiIconButton-root': {
        padding: 6,
        marginLeft: '2px !important',
      },
    },
  },
  [`& .${itemsClasses.deleteBtn}`]: {
    margin: 4,
  },
  [`& .${itemsClasses.alertBtn}`]: {
    color: theme.palette.getContrastText(red[600]),
    backgroundColor: red[600],
    '&:hover': {
      backgroundColor: red[700],
    },
  },
  [`& .${itemsClasses.linkReset}`]: {
    color: 'inherit',
    textDecoration: 'inherit'
  },
  [`& .${itemsClasses.iconSmall}`]: {
    fontSize: 22,
  },
  [`& .${itemsClasses.infoBox}`]: {
    borderRadius: 0,
    ...theme.mixins.frostedSurface(theme.palette.errorBar.background),
    padding: '12px 24px',
    border: `solid 1px ${theme.palette.divider}`
  },
  [`& .${itemsClasses.infoText}`]: {
    color: theme.palette.errorBar.text,
  },
  [`& .${itemsClasses.menuPaper}`]: {
    maxHeight: 360
  },
  [`& .${itemsClasses.disabledInfo}`]: {
    position: 'fixed',
    top: '50%',
    left: 'calc(50% + 36px)',
    transform: 'translate(-50%, -50%)',
    textAlign: 'center',
    fontSize: '1.5rem',
    [theme.breakpoints.down('sm')]: {
      left: '50%',
      fontSize: '1.1rem',
      padding: '0 16px',
    },
  },
  // an item's icon takes a fixed column in front of the title; the subtitle moves over by the
  // same width so it stays under the title text, not under the icon
  [`& .${itemsClasses.itemIcon}`]: {
    display: 'inline-flex',
    width: ICON_COLUMN,
    verticalAlign: 'text-bottom',
    opacity: .7,
  },
  [`& .${itemsClasses.itemSubtitle}`]: {
    position: 'absolute',
    left: 73,
    top: 33,
    fontSize: 11,
    color: theme.palette.text.secondary,
    '&.with-icon': {
      left: 73 + ICON_COLUMN,
    },
    [theme.breakpoints.down('sm')]: {
      position: 'relative',
      left: 'unset',
      top: 'unset',
      display: 'block',
      paddingLeft: theme.spacing(4),
      marginTop: -4,
      '&.with-icon': {
        left: 'unset',
        paddingLeft: `calc(${theme.spacing(4)} + ${ICON_COLUMN}px)`,
      },
    },
  },
  [`& .${itemsClasses.itemTitle}`]: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    display: 'inline-block',
    maxWidth: 'calc(100% - 180px)',
    verticalAlign: 'middle',
    [theme.breakpoints.down('sm')]: {
      maxWidth: '100%',
      display: 'block',
    },
  },
  // matches the navigation's NEW badge, see Navigation.js badgeStyle
  [`& .${itemsClasses.newBadge}`]: {
    backgroundColor: 'transparent',
    color: theme.palette.secondary.main,
    border: `1px solid ${theme.palette.secondary.main}`,
    fontWeight: '500 !important',
    fontSize: '0.6rem',
    height: 16,
    flexShrink: 0,
    marginLeft: 12,
    verticalAlign: 'middle',
    '& .MuiChip-label': {
      paddingLeft: 4,
      paddingRight: 4,
    },
  },
  // the outer Paper stops being the card so each group can be one. backgroundImage too:
  // MUI paints its dark-theme elevation overlay with it
  [`& .${itemsClasses.groupedRoot}`]: {
    backgroundColor: 'transparent',
    backgroundImage: 'none',
    boxShadow: 'none',
    // keyed off data-tour, not ItemsListToolbar-root - the unsaved-changes bar shares
    // that class and paints its own colour
    // looks like the group cards (Paper, elevation 3): in dark mode MUI lightens Paper with an
    // elevation overlay a plain box does not get, so the bar came out darker than the cards
    '& [data-tour="items-filter-bar"]': {
      backgroundColor: theme.palette.background.paper,
      backgroundImage: theme.palette.mode === 'dark' ? 'linear-gradient(rgba(255, 255, 255, 0.08), rgba(255, 255, 255, 0.08))' : 'none',
      borderRadius: theme.shape.borderRadius,
      boxShadow: theme.shadows[3],
    },
    // the gap goes on the cards, not the bar: when the bar sticks it is wrapped in a
    // fixed, white-backgrounded element, and a margin there paints as a white band
    [`& .${itemsClasses.tableWrapper}`]: {
      paddingTop: GROUP_GAP,
    },
    // separated the filter bar from the list back when both sat in one card
    '& > hr': {
      display: 'none',
    },
  },
  // no overflow:hidden, it would break the sticky row header. The last row's divider
  // would draw a line along the card's bottom edge
  [`& .${itemsClasses.groupCard}`]: {
    marginBottom: GROUP_GAP,
    [`& .ItemsList_list-item:last-child > hr:last-child`]: {
      display: 'none',
    },
  },
  // sits inside its group's card, indented to the same 24px as the rows below it
  // what a group holds, in a smaller line under its label
  [`& .${itemsClasses.groupInfo}`]: {
    padding: '0 24px 16px',
    marginTop: -12,
  },
  [`& .${itemsClasses.groupLabel}`]: {
    padding: '20px 24px 16px',
  },
  // dark mode dims less: 65% of the light text on the dark panel is hard to read
  [`& .${itemsClasses.itemTitleDimmed}`]: {
    opacity: theme.palette.mode === 'dark' ? .8 : .65,
  },
  [`& .${itemsClasses.itemTitleError}`]: {
    color: theme.palette.error.main,
    fontWeight: 'bold',
  },
  [`& .${itemsClasses.itemErrorIcon}`]: {
    position: 'absolute',
    left: 21,
    top: 17,
    width: '1.25em',
    height: '1.25em',
    color: theme.palette.error.main,
    backgroundColor: theme.palette.background.paper,
    borderRadius: '1em',
  },
  [`& .${itemsClasses.syncStatus}`]: {
    fontSize: '0.85em',
    color: theme.palette.text.secondary,
    marginLeft: 8,
  },
  [`& .${itemsClasses.shopifyId}`]: {
    marginRight: 12,
    float: "right",
    border: "none",
    fontWeight: 'normal !important',
    [theme.breakpoints.down('sm')]: {
      float: 'none',
      display: 'block',
      marginRight: 0,
      marginLeft: 2,
      marginTop: 2,
      height: 'auto',
      fontSize: 11,
      opacity: 0.6,
    },
  },
}));

ItemsList.propTypes = {
};
ItemsList.defaultProps = {
  isSticky: true,
  paginate: true,
  allowFieldFiltering: false,
}

const mapStateToProps = ({ shop, themes, languages, bulkTranslation }) => ({
  shop: shop,
  themes: themes,
  languages: languages,
  editLanguage: shop.shop.edit_language,
  bulkTranslationTasks: bulkTranslation.tasks
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setUnsavedEdits,
    },
    dispatch
  )

// Inject itemsClasses as 'classes' prop for backward compatibility
const ConnectedItemsList = withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(withSnackbar(ItemsList))));

export default (props) => (
  <ItemsListRoot>
    <ConnectedItemsList {...props} classes={itemsClasses} />
  </ItemsListRoot>
);

